/*
 * Tracking Common JS
 *
 */
const prefixData = window.relewiseAPI.relewise_prefix_data;
const relewiseCountry = window.relewiseAPI.relewise_country;

const PRODUCT_DATA_KEYS = [
  'IsAvailable',
  'Tags',
  `${prefixData}_ShopifyHandle`,
  `${prefixData}_ImageUrls`,
  `${prefixData}_pim.author`,
  `${prefixData}_pim.global_binding`,
  `${prefixData}_pim.language`,
  `${prefixData}_pim.badges`,
  `${prefixData}_pim.book`,
  `${prefixData}_custom.kobslogik`,
  `${prefixData}_judgeme.review_widget_data`
];

const RECENT_SEARCHES_KEY = 'relewise_recent_searches';
const RECENT_SEARCHES_MAX = 3;
window.relewiseContentSearchCache = window.relewiseContentSearchCache || {};

function saveSearchTerm(term) {
  if (!term || !term.trim()) return;
  term = term.trim();
  let searches = getRecentSearches();
  searches = searches.filter(s => s.toLowerCase() !== term.toLowerCase());
  searches.unshift(term);
  searches = searches.slice(0, RECENT_SEARCHES_MAX);
  try {
    localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(searches));
  } catch (e) {}
}

function getRecentSearches() {
  try {
    const stored = localStorage.getItem(RECENT_SEARCHES_KEY);
    if (stored) return JSON.parse(stored);
  } catch (e) {}
  return [];
}

function clearSearchHistory() {
  try {
    localStorage.removeItem(RECENT_SEARCHES_KEY);
  } catch (e) {}
}

function buildAuthenticatedUser() {
  const user = {
    "Classifications": { "Country": `${relewiseCountry}` },
    "Identifiers": {},
    "AuthenticatedId": window.relewiseAPI.customer_id,
    "Data": {}
  };
  // KundeklubMedlemskabsId is only set for newsletter subscribers so it can be used as a
  // narrow trigger audience (AuthenticatedId alone would be too broad).
  if (window.relewiseAPI.customer_accepts_marketing) {
    // user.Identifiers.MemberId = window.relewiseAPI.customer_id;
    user.Identifiers.KundeklubMedlemskabsId = window.relewiseAPI.customer_club_trigger_id;
  }
  return user;
}

function buildTemporaryUser() {
  return {
    "Classifications": { "Country": `${relewiseCountry}` },
    "Identifiers": {},
    "TemporaryId": getVisitorId(),
    "Data": {}
  };
}

function getUserData() {
  if (Shopify && Shopify.customerPrivacy) {
    let currentConsent = Shopify.customerPrivacy.currentVisitorConsent();
    if (currentConsent && currentConsent.marketing == 'yes' && currentConsent.analytics == 'yes') {
      return window.relewiseAPI.customer_id ? buildAuthenticatedUser() : buildTemporaryUser();
    }
  } else if (sessionStorage.getItem('consent_accepted') == 'true') {
    return window.relewiseAPI.customer_id ? buildAuthenticatedUser() : buildTemporaryUser();
  }
  return {
    "Classifications": { "Country": `${relewiseCountry}` },
    "Identifiers": {},
    "Data": {}
  };
}

let _popularProductsCache = null;
let _popularProductsCacheCount = null;

function getPopularProductsForSearch(count = 8) {
  if (_popularProductsCache && _popularProductsCacheCount === count) {
    return _popularProductsCache;
  }

  const settings = {
    language: `${window.themeVariables.settings.languages}`,
    currency: `${window.themeVariables.settings.shopCurrency}`,
    displayedAtLocation: 'Search overlay',
    user: getUserData()
  };
  const builder = new Relewise.PopularProductsBuilder(settings)
    .setSelectedProductProperties({
      displayName: true,
      dataKeys: PRODUCT_DATA_KEYS,
      pricing: true
    })
    .setSelectedVariantProperties({ dataKeys: [`${prefixData}_ShopifyVariantId`] })
    .setNumberOfRecommendations(count)
    .build();

  const recommender = new Relewise.Recommender(window.relewiseAPI.relewise_dataid, window.relewiseAPI.relewise_api, {
    serverUrl: window.relewiseAPI.relewise_server_url,
  });

  _popularProductsCache = recommender.recommendPopularProducts(builder);
  _popularProductsCacheCount = count;
  return _popularProductsCache;
}

// header search
function getProductLayerSearchDropDown(queryKey) {
  let productNumber = 8;
  let categoryNumber = 8;
  const settings = {
    language: `${window.themeVariables.settings.languages}`,
    currency: `${window.themeVariables.settings.shopCurrency}`,
    displayedAtLocation: 'Search overlay',
    user: getUserData()
  };
  const builder = new Relewise.SearchCollectionBuilder(settings)
    .addRequest(new Relewise.ProductSearchBuilder(settings)
      .setSelectedProductProperties({
        displayName: true,
        dataKeys: PRODUCT_DATA_KEYS,
        pricing: true
      })
      .setSelectedVariantProperties({ dataKeys: [`${prefixData}_ShopifyVariantId`] })
      .setExplodedVariants(1)
      .setTerm(queryKey)
      .pagination(p => p
          .setPageSize(productNumber)
          .setPage(1))
      .build())
    .addRequest(new Relewise.ProductCategorySearchBuilder(settings)
      .setSelectedCategoryProperties({
          displayName: true,
          dataKeys: ['Handle'],
      })
      .setTerm(queryKey)
      .pagination(p => p
          .setPageSize(categoryNumber)
          .setPage(1))
      .build()
    )
    .addRequest(new Relewise.SearchTermPredictionBuilder(settings)
      .setTerm(queryKey)
      .take(3)
      .build());

  const searcher = new Relewise.Searcher(window.relewiseAPI.relewise_dataid, window.relewiseAPI.relewise_api, {
    serverUrl: window.relewiseAPI.relewise_server_url,
  });
  return searcher.batch(builder.build())
}

function getContentSearch(queryKey, contentNumber, displayedAtLocation) {
  const settings = {
    language: `${window.themeVariables.settings.languages}`,
    currency: `${window.themeVariables.settings.shopCurrency}`,
    displayedAtLocation: displayedAtLocation,
    user: getUserData()
  };
  const builder = new Relewise.SearchCollectionBuilder(settings)
    .addRequest(new Relewise.ContentSearchBuilder(settings)
      .setContentProperties({
        displayName: true,
        dataKeys: ['Handle', 'BlogHandle', 'Type', 'TemplateSuffix'],
      })
      .setTerm(queryKey)
      .pagination(p => p
          .setPageSize(contentNumber)
          .setPage(1))
      .build());

  const searcher = new Relewise.Searcher(window.relewiseAPI.relewise_dataid, window.relewiseAPI.relewise_api, {
    serverUrl: window.relewiseAPI.relewise_server_url,
  });
  return searcher.batch(builder.build())
}

function getContentSearchDropDown(queryKey) {
  return getContentSearch(queryKey, 8, 'Search overlay');
}

// header search terms click
document.addEventListener('click', function(event) {
  if (event.target.closest('.rl-search-term')) {
    event.preventDefault();
    let term = event.target.closest('.rl-search-term').dataset.term;
    let currentValue = document.querySelector('search-drawer input[name="q"]').value;
    if (currentValue == term) {
      return;
    }
    document.querySelector('search-drawer input[name="q"]').value = term;
    document.querySelector('search-drawer input[name="q"]').dispatchEvent(new Event('input'));
  }
});

// search page
function getProductLayerSearchPage(queryKey, productPerPage, page, sorting = '', facets = {}) {
  window.currentSearchPage = page;
  let categoryNumber = 200;
  const settings = {
    language: `${window.themeVariables.settings.languages}`,
    currency: `${window.themeVariables.settings.shopCurrency}`,
    displayedAtLocation: 'Search page',
    user: getUserData()
  };
  const builder = new Relewise.SearchCollectionBuilder(settings)
    .addRequest(new Relewise.ProductSearchBuilder(settings)
      .setSelectedProductProperties({
        displayName: true,
        dataKeys: PRODUCT_DATA_KEYS,
        pricing: true
      })
      .setSelectedVariantProperties({ dataKeys: [`${prefixData}_ShopifyVariantId`] })
      .setExplodedVariants(1)
      .setTerm(queryKey)
      .facets((f) => {
        if (facets.hasOwnProperty(`${prefixData}_pim.number_of_participants`)) {
          f.addProductDataStringValueFacet(`${prefixData}_pim.number_of_participants`, 'Product', facets[`${prefixData}_pim.number_of_participants`])
        } else {
          f.addProductDataStringValueFacet(`${prefixData}_pim.number_of_participants`)
        }
        if (facets.hasOwnProperty(`${prefixData}_pim.age`)) {
          f.addProductDataStringValueFacet(`${prefixData}_pim.age`, 'Product', facets[`${prefixData}_pim.age`])
        } else {
          f.addProductDataStringValueFacet(`${prefixData}_pim.age`)
        }
        if (facets.hasOwnProperty(`${prefixData}_pim.publisher`)) {
          f.addProductDataStringValueFacet(`${prefixData}_pim.publisher`, 'Product', facets[`${prefixData}_pim.publisher`])
        } else {
          f.addProductDataStringValueFacet(`${prefixData}_pim.publisher`)
        }
        if (facets.hasOwnProperty(`${prefixData}_pim.series_name_reference`)) {
          f.addProductDataStringValueFacet(`${prefixData}_pim.series_name_reference`, 'Product', facets[`${prefixData}_pim.series_name_reference`])
        } else {
          f.addProductDataStringValueFacet(`${prefixData}_pim.series_name_reference`)
        }
        if (facets.hasOwnProperty(`${prefixData}_pim.author`)) {
          f.addProductDataStringValueFacet(`${prefixData}_pim.author`, 'Product',facets[`${prefixData}_pim.author`])
        } else {
          f.addProductDataStringValueFacet(`${prefixData}_pim.author`)
        }
        if (facets.hasOwnProperty(`${prefixData}_pim.brand`)) {
          f.addProductDataStringValueFacet(`${prefixData}_pim.brand`, 'Product', facets[`${prefixData}_pim.brand`])
        } else {
          f.addProductDataStringValueFacet(`${prefixData}_pim.brand`)
        }
        if (facets.hasOwnProperty('filter.v.price.gte') || facets.hasOwnProperty('filter.v.price.lte')) {
          f.addSalesPriceRangeFacet('Product', facets['filter.v.price.gte'] || null, facets['filter.v.price.lte'] || null);
        } else {
          f.addSalesPriceRangeFacet();
        }
        if (facets.hasOwnProperty(`${prefixData}_pim.global_binding`)) {
          f.addProductDataStringValueFacet(`${prefixData}_pim.global_binding`, 'Product', facets[`${prefixData}_pim.global_binding`])
        } else {
          f.addProductDataStringValueFacet(`${prefixData}_pim.global_binding`)
        }
        if (facets.hasOwnProperty(`${prefixData}_pim.language`)) {
          f.addProductDataStringValueFacet(`${prefixData}_pim.language`, 'Product', facets[`${prefixData}_pim.language`])
        } else {
          f.addProductDataStringValueFacet(`${prefixData}_pim.language`)
        }
        if (facets.hasOwnProperty(`${prefixData}_pim.purchasing_group`)) {
          f.addProductDataStringValueFacet(`${prefixData}_pim.purchasing_group`, 'Product', facets[`${prefixData}_pim.purchasing_group`])
        } else {
          f.addProductDataStringValueFacet(`${prefixData}_pim.purchasing_group`)
        }
      })
      .pagination(p => p
          .setPageSize(productPerPage)
          .setPage(page))
      .sorting((s) => {
        switch (sorting) {
          case 'title-ascending':
            s.sortByProductAttribute('DisplayName', 'Ascending', (n) => n.sortByProductRelevance())
            break;
          case 'title-descending':
            s.sortByProductAttribute('DisplayName', 'Descending', (n) => n.sortByProductRelevance())
            break;
          case 'price-ascending':
            s.sortByProductAttribute('SalesPrice', 'Ascending', (n) => n.sortByProductRelevance())
            break;
          case 'price-descending':
            s.sortByProductAttribute('SalesPrice', 'Descending', (n) => n.sortByProductRelevance())
            break;
          case 'created-descending':
            s.sortByProductData(`${prefixData}_pim.publication_date_timestamp`, 'Product', 'Descending', (n) => n.sortByProductRelevance())
            break;
          case 'best-selling':
            s.sortByProductPopularity('Descending', (n) => n.sortByProductRelevance())
            break;
          default:
            break;
        }
      })
      .build())
    .addRequest(new Relewise.ProductCategorySearchBuilder(settings)
      .setSelectedCategoryProperties({
          displayName: true,
          dataKeys: ['Handle'],
      })
      .setTerm(queryKey)
      .pagination(p => p
          .setPageSize(categoryNumber)
          .setPage(1))
      .build()
    );

  const searcher = new Relewise.Searcher(window.relewiseAPI.relewise_dataid, window.relewiseAPI.relewise_api, {
    serverUrl: window.relewiseAPI.relewise_server_url,
  });
  return searcher.batch(builder.build())
}

function getContentSearchPage(queryKey) {
  return getContentSearch(queryKey, 200, 'Search page');
}

function getRelewiseContentSearchCacheKey(queryKey, context) {
  let language = window.themeVariables.settings.languages;
  return `${language}:${context}:${queryKey.trim().toLowerCase()}`;
}

function getCachedRelewiseContentSearch(queryKey, context) {
  let cacheKey = getRelewiseContentSearchCacheKey(queryKey, context);
  let cachedSearch = window.relewiseContentSearchCache[cacheKey];
  if (cachedSearch?.data) {
    return Promise.resolve(cachedSearch.data);
  }
  if (cachedSearch?.promise) {
    return cachedSearch.promise;
  }

  let searchFunction = context == 'drawer' ? getContentSearchDropDown : getContentSearchPage;
  let cacheEntry = {};
  cacheEntry.promise = searchFunction(queryKey)
    .then(data => {
      cacheEntry.data = data;
      return data;
    })
    .catch(error => {
      delete window.relewiseContentSearchCache[cacheKey];
      throw error;
    });
  window.relewiseContentSearchCache[cacheKey] = cacheEntry;
  return cacheEntry.promise;
}

function buildSearchFacetsToolbarHtml() {
  let tpl = document.getElementById('relewise-search-facets-toolbar-template');
  if (!tpl) return '';
  return tpl.innerHTML;
}

function renderRelewiseSearchPage(productTerms, page, productPerPage, sorting = '', facets = {}) {
  window.currentSorting = sorting;
  return getProductLayerSearchPage(productTerms, productPerPage, page, sorting, facets).then((data) => {
    let skeleton = document.querySelector(".relewise-skeleton");
    let tabs = skeleton.querySelector(".predictive-search__tabs");
    let searchWrapper = document.querySelector('.relewise-search-page-wrapper');
    let showFilters = searchWrapper.dataset.showFilters === 'true';
    let showSortBy = searchWrapper.dataset.showSortBy === 'true';
    let hasFacetsUi = document.querySelector('#facets-drawer.facets-drawer-relewise') !== null;

    searchWrapper.innerHTML = `<div class="relewise-skeleton-wrapper relewise-search-wrapper h-stack gap-6 sm:gap-10 align-start">
      <div class="predictive-search__tabs-wrapper relative">
        <x-tabs class="predictive-search__tabs">${tabs.innerHTML}</x-tabs>
      </div>
      </div>`;
    initializeLazyRelewiseContent(searchWrapper, productTerms);

    let productsResponse = getResultsFromResponse(data, 'product');
    let products = productsResponse.results;
    let productHits = productsResponse.hits;

    let categoriesResponse = getResultsFromResponse(data, 'category');
    let categories = categoriesResponse.results;

    let productsTabContent = document.querySelector('.relewise-search-page-wrapper .predictive-search__tab-content[data-type="products"]');
    productsTabContent.classList.remove('h-stack', 'gap-5', 'wrap', 'align-start');

    let productsWrapper;
    if (hasFacetsUi) {
      productsTabContent.classList.add('has-relewise-filter-ui');
      productsTabContent.innerHTML = buildSearchFacetsToolbarHtml() +
        `<div class="v-stack gap-6">
          <div class="v-stack gap-4 md:hidden">
            <p class="text-center rlw-product-count"></p>
            ${showFilters ? '<div class="active-facets-wrapper"></div>' : ''}
          </div>
          <product-list class="product-list" role="region" aria-live="polite"></product-list>
        </div>`;
      productsWrapper = productsTabContent.querySelector('.product-list');
    } else {
      productsTabContent.classList.remove('has-relewise-filter-ui');
      productsTabContent.classList.add('product-list');
      productsWrapper = productsTabContent;
    }

    if (products.length) {
      products.forEach(product => {
        let productSkeleton = buildProductCardHtml(product);
        productsWrapper.appendChild(productSkeleton);
      });
      window.alignHeight('.relewise-product-card .rpc-author', productsWrapper);
    } else {
      productsWrapper.innerHTML = `<div class="text-sm text-subdued">${window.themeVariables.ir.search.noProductsFound}</div>`;
    }

    if (hasFacetsUi) {
      let productCountElement = document.querySelector('.relewise-search-page-wrapper .rlw-product-count');
      if (productCountElement) {
        productCountElement.textContent = window.themeVariables.ir.collection.product_count.replace('[count]', productHits);
      }
      renderCollectionFacets(data, '.relewise-search-page-wrapper');
    }

    // pagination UI
    let paginationElement = document.querySelector('.search__pagination-relewise');
    if (paginationElement) {
      let numberOfPages = Math.ceil(productHits / productPerPage);
      window.searchPageTotalPages = numberOfPages;
      if (numberOfPages > 1) {
        paginationElement.classList.remove('hidden');
        paginationElement.querySelector('.pagination__current').textContent = `${window.currentSearchPage}  /  ${numberOfPages}`;
        if (window.currentSearchPage <= 1) {
          paginationElement.querySelector('.pagination__item[rel="prev"]').classList.add('pagination__item--disabled');
        } else {
          paginationElement.querySelector('.pagination__item[rel="prev"]').classList.remove('pagination__item--disabled');
        }
        if (window.currentSearchPage >= numberOfPages) {
          paginationElement.querySelector('.pagination__item[rel="next"]').classList.add('pagination__item--disabled');
        } else {
          paginationElement.querySelector('.pagination__item[rel="next"]').classList.remove('pagination__item--disabled');
        }
      } else {
        paginationElement.classList.add('hidden');
      }
    }

    // sync URL with search query, page, sort and facets
    let param = new URL(window.location.href);
    param.searchParams.set('q', productTerms);
    if (window.currentSearchPage > 1) {
      param.searchParams.set('page', window.currentSearchPage);
    } else {
      param.searchParams.delete('page');
    }
    if (sorting && sorting !== 'manual') {
      param.searchParams.set('sort_by', sorting);
    } else {
      param.searchParams.delete('sort_by');
    }
    // clean stale filter params
    let staleKeys = [];
    param.searchParams.forEach((_value, key) => {
      if (key.startsWith('rlw_') || key === 'filter.v.price.gte' || key === 'filter.v.price.lte') {
        staleKeys.push(key);
      }
    });
    staleKeys.forEach(key => param.searchParams.delete(key));
    Object.keys(facets).forEach(key => {
      if (key === 'sort_by') return;
      let paramKey = key.replace(`${prefixData}_`, 'rlw_');
      if (Array.isArray(facets[key])) {
        if (facets[key].length) {
          param.searchParams.set(paramKey, facets[key].join(','));
        }
      } else if (facets[key]) {
        param.searchParams.set(paramKey, facets[key]);
      }
    });
    window.history.replaceState(null, '', param.href);

    let categoriesWrapper = document.querySelector('.relewise-search-page-wrapper .predictive-search__tab-content[data-type="collections"]');
    if (categories.length) {
      categories.forEach(category => {
        let categoryHtml = `<a href="/collections/${category.data?.Handle?.value}" title="${category.displayName}" class=" bold block">${category.displayName}</a>`;
        categoriesWrapper.innerHTML += categoryHtml;
      });
    } else {
      categoriesWrapper.innerHTML = `<div class="text-sm text-subdued">${window.themeVariables.ir.search.noCategoriesFound}</div>`;
    }

  });
}

function renderPopularProductsOnSearchPage(productPerPage) {
  let wrapper = document.querySelector('.relewise-search-page-wrapper');
  wrapper.innerHTML = '';

  let paginationElement = document.querySelector('.search__pagination-relewise');
  if (paginationElement) {
    paginationElement.classList.add('hidden');
  }

  let heading = document.createElement('p');
  heading.className = 'bold text-subdued';
  heading.textContent = window.themeVariables.ir.search.popularProducts;
  wrapper.appendChild(heading);

  let grid = document.createElement('div');
  grid.className = 'search-popular-products-grid';
  wrapper.appendChild(grid);

  let param = new URL(window.location.href);
  param.searchParams.delete('q');
  param.searchParams.delete('page');
  window.history.replaceState(null, '', param.href);

  getPopularProductsForSearch(productPerPage).then((data) => {
    if (!data?.recommendations?.length) return;
    for (const product of data.recommendations) {
      let card = buildProductCardHtml(product);
      grid.appendChild(card);
    }
    window.alignHeight('.relewise-product-card .rpc-author', grid);
  }).catch((error) => {
    console.log(error);
  });
}

// helper: get results for each type from relewise response data
function getResultsFromResponse(data, type) {
  let results = [];
  let hits = 0;
  let response = null;
  if (type == 'product') {
    response = data.responses.find(
      item => item['$type'].indexOf('ProductSearchResponse') !== -1
    );
    hits = response ? response.hits : 0;
    results = response ? response.results : [];
  } else if (type == 'category') {
    response = data.responses.find(
      item => item['$type'].indexOf('ProductCategorySearchResponse') !== -1
    );
    hits = response ? response.hits : 0;
    results = response ? response.results : [];
  } else if (type == 'content') {
    response = data.responses.find(
      item => item['$type'].indexOf('ContentSearchResponse') !== -1
    );
    hits = response ? response.hits : 0;
    results = response ? response.results : [];
  } else if (type == 'prediction') {
    response = data.responses.find(
      item => item['$type'].indexOf('SearchTermPredictionResponse') !== -1
    );
    results = response ? response.predictions : [];
  }
  return {
    results: results,
    hits: hits
  };
}

function initializeLazyRelewiseContent(container, queryKey) {
  let tabs = container.matches?.('x-tabs.predictive-search__tabs')
    ? container
    : container.querySelector('.relewise-search-wrapper x-tabs.predictive-search__tabs');
  if (!tabs) {
    return;
  }

  tabs.dataset.relewiseQuery = queryKey.trim();
  tabs.dataset.relewiseContentState = 'idle';
  let contentWrappers = tabs.querySelectorAll('.predictive-search__tab-content[data-type="posts"], .predictive-search__tab-content[data-type="pages"]');
  for (const contentWrapper of contentWrappers) {
    contentWrapper.innerHTML = '';
    contentWrapper.removeAttribute('aria-busy');
  }

  let contentTabButtons = tabs.querySelectorAll('.predictive-search__tab-item[data-type="posts"] button, .predictive-search__tab-item[data-type="pages"] button');
  for (const contentTabButton of contentTabButtons) {
    contentTabButton.addEventListener('click', () => loadLazyRelewiseContent(contentTabButton));
  }
}

function setRelewiseContentLoading(container) {
  let contentWrappers = container.querySelectorAll('.predictive-search__tab-content[data-type="posts"], .predictive-search__tab-content[data-type="pages"]');
  for (const contentWrapper of contentWrappers) {
    contentWrapper.setAttribute('aria-busy', 'true');
    contentWrapper.innerHTML = '<span class="skeleton skeleton--text" style="--skeleton-text-width: 40%"></span>';
  }
}

function renderRelewiseContentResults(container, data, excludeCampaignForm) {
  let contents = getResultsFromResponse(data, 'content').results;
  let postsWrapper = container.querySelector('.predictive-search__tab-content[data-type="posts"]');
  let pagesWrapper = container.querySelector('.predictive-search__tab-content[data-type="pages"]');
  let postsExisted = false;
  let pagesExisted = false;

  postsWrapper.innerHTML = '';
  pagesWrapper.innerHTML = '';
  postsWrapper.removeAttribute('aria-busy');
  pagesWrapper.removeAttribute('aria-busy');

  for (const content of contents) {
    let type = content.data?.Type?.value;
    let handle = content.data?.Handle?.value;
    let templateSuffix = content.data?.TemplateSuffix?.value;
    if (type == 'Article') {
      postsExisted = true;
      let blogHandle = content.data?.BlogHandle?.value;
      postsWrapper.innerHTML += `<a href="/blogs/${blogHandle}/${handle}" title="" class=" bold block">${content.displayName}</a>`;
    } else if (type == 'Page' && (!excludeCampaignForm || templateSuffix != 'campaign-form')) {
      pagesExisted = true;
      pagesWrapper.innerHTML += `<a href="/pages/${handle}" title="" class=" bold block">${content.displayName}</a>`;
    } else if (type == 'Metaobject') {
      pagesExisted = true;
      pagesWrapper.innerHTML += `<a href="/pages/${handle}" title="" class=" bold block">${content.displayName}</a>`;
    }
  }

  if (!postsExisted) {
    postsWrapper.innerHTML = `<div class="text-sm text-subdued">${window.themeVariables.ir.search.noPostsFound}</div>`;
  }
  if (!pagesExisted) {
    pagesWrapper.innerHTML = `<div class="text-sm text-subdued">${window.themeVariables.ir.search.noPagesFound}</div>`;
  }
  container.dataset.relewiseContentState = 'loaded';
}

function loadLazyRelewiseContent(tabButton) {
  let container = tabButton.closest('x-tabs.predictive-search__tabs');
  let searchPageWrapper = container?.closest('.relewise-search-page-wrapper');
  if (!container || container.dataset.relewiseContentState == 'loading' || container.dataset.relewiseContentState == 'loaded') {
    return;
  }

  let queryKey = container.dataset.relewiseQuery;
  if (!queryKey) {
    return;
  }

  let context = searchPageWrapper ? 'page' : 'drawer';
  container.dataset.relewiseContentState = 'loading';
  setRelewiseContentLoading(container);

  getCachedRelewiseContentSearch(queryKey, context)
    .then(data => {
      if (container.dataset.relewiseQuery != queryKey) {
        return;
      }
      renderRelewiseContentResults(container, data, context == 'drawer');
    })
    .catch(error => {
      if (container.dataset.relewiseQuery == queryKey) {
        initializeLazyRelewiseContent(container, queryKey);
      }
      throw error;
    });
}

// helper: build product card html
function buildProductCardHtml(product) {
  let productSkeleton = document.querySelector('.relewise-product-card-skeleton').cloneNode(true);

  productSkeleton.classList.remove('relewise-product-card-skeleton');
  let pHandleData = product.data && product.data[`${window.relewiseAPI.relewise_prefix_data}_ShopifyHandle`];
  let pHandle = '';
  let pUrl = '';
  if (pHandleData && pHandleData.value) {
    pHandle = pHandleData.value;
    pUrl = `/products/${pHandle}`;
  }

  let imgHtml = '';
  const imageUrlsData = product.data && product.data[`${window.relewiseAPI.relewise_prefix_data}_ImageUrls`];
  if (
    imageUrlsData &&
    imageUrlsData.value &&
    imageUrlsData.value.$values &&
    Array.isArray(imageUrlsData.value.$values) &&
    imageUrlsData.value.$values.length > 0
  ) {
    imgHtml = `<a href="${pUrl}" title="" class="block"><img class="product-card__image product-card__image--primary  aspect-custom" src="${imageUrlsData.value.$values[0]}" loading="lazy" alt="${product.displayName}" width="204"></a>`;
  } else {
    imgHtml = `<a href="${pUrl}" title="" class="block"><img class="product-card__image product-card__image--primary  aspect-custom" src="${window.themeVariables.ir.product.fallbackImage}" loading="lazy" alt="${product.displayName}" width="204"></a>`;
  }
  let isPriceZero = window.themeVariables?.settings?.hideZeroPrice && product.salesPrice === 0;

  // quick add
  let variantId = product.variant && product.variant.data && product.variant.data[`${window.relewiseAPI.relewise_prefix_data}_ShopifyVariantId`]
    ? product.variant.data[`${window.relewiseAPI.relewise_prefix_data}_ShopifyVariantId`].value
    : undefined;
  if (variantId && product.data?.IsAvailable?.value == true) {
    imgHtml += `<div class="product-card__quick-buy"${isPriceZero ? ' style="display:none"' : ''}>
      <form method="post" action="/cart/add" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data" is="product-form">
        <input type="hidden" name="form_type" value="product">
        <input type="hidden" name="utf8" value="✓">
        <input type="hidden" name="id" value="${variantId}">
        <button type="submit" is="custom-button" class="product-card__mobile-quick-buy-button" aria-label="+ Hurtig tilføjelse">
          <div>
            <svg role="presentation" focusable="false" width="50" height="50" class="icon icon-quick-buy-cart" viewBox="0 0 100 100">
              <circle cx="50" cy="50" r="45" fill="#e52424"></circle><path stroke="#fff" stroke-linecap="round" stroke-width="4" d="M68 18v16M60 26h16"></path><path fill="none" stroke="#fff" stroke-linecap="round" stroke-width="4" d="M38 46a12 12 0 0 1 24 0"></path><path fill="none" stroke="#fff" stroke-linejoin="round" stroke-width="4" d="M30 46h40l-6 26H36Z"></path>
            </svg>
          </div>
          <span class="button__loader">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
        <input type="hidden" name="product-id" value="${product.productId}">
      </form></div>`;
  }

  let pTitleHtml = '';
  if (product.displayName) {
    pTitleHtml = `<a href="${pUrl}" title="${product.displayName}" class="text-sm bold block">${product.displayName}</a>`;
  }

  let authorHtml = '';
  const authorsData = product.data && product.data[`${window.relewiseAPI.relewise_prefix_data}_pim.author`];
  if (
    authorsData &&
    authorsData.value &&
    authorsData.value.$values &&
    Array.isArray(authorsData.value.$values) &&
    authorsData.value.$values.length > 0
  ) {
    authorHtml = `<div class="author-list">${authorsData.value.$values.join(', ')}</div>`;
  }

  let tags = product?.data?.Tags?.value?.$values;
  let hasCampaignTag = Array.isArray(tags) && tags.some(t => typeof t === 'string' && t.toLowerCase().startsWith('campaign'));
  let isOnSale = (product.listPrice && product.listPrice > product.salesPrice) || hasCampaignTag;

  let priceHtml = `<div class="rl-product-prices h-stack gap-2"${isPriceZero ? ' style="display:none"' : ''}>`;
  if (product.salesPrice || product.salesPrice === 0) {
    priceHtml += `<span class="rl-product-price ${isOnSale ? 'text-on-sale' : ''}">${Shopify.formatMoney(product.salesPrice * 100)}</span>`;
  }
  if (product.listPrice && product.listPrice > product.salesPrice) {
    priceHtml += `<span class="rl-product-price-old line-through">${Shopify.formatMoney(product.listPrice * 100)}</span>`;
  }
  priceHtml += '</div>';

  productSkeleton.querySelector('.rpc-image').innerHTML = imgHtml || '';
  productSkeleton.querySelector('.rpc-title').innerHTML = pTitleHtml || '';
  productSkeleton.querySelector('.rpc-author').innerHTML = authorHtml || '';
  productSkeleton.querySelector('.rpc-price').innerHTML = priceHtml;

  if (product.data) {
    let bottomBadgesHtml = '';
    if (product.data[`${window.relewiseAPI.relewise_prefix_data}_pim.global_binding`]) {
      let bindingType = product.data[`${window.relewiseAPI.relewise_prefix_data}_pim.global_binding`].value;
      if (bindingType) {
        let flagImgSrc = '';
        if (product.data[`${window.relewiseAPI.relewise_prefix_data}_pim.language`]) {
          let language = product.data[`${window.relewiseAPI.relewise_prefix_data}_pim.language`].value;
          if (language) {
            language = language.toLowerCase().trim();
            let isDanish = false;
            let notHaveFlag = [
              'dk', 'da', 'dan', 'da-dk', 'da_dk', 'und', 'mul', 'kal', 'enu',
              'sproget kan ikke bestemmes',
              'mis', 'latin', 'nno', 'nob', 'aramæisk', 'enm',
              'koreansk','mar', 'srp', 'sme','prs'
            ];
            if (
              notHaveFlag.includes(language) ||
              language.includes('dansk') ||
              language.includes('danish') ||
              language.includes('bokmål') ||
              language.includes('flere')
            ) {
              isDanish = true;
            }
            if (!isDanish) {
              if (language == 'catalansk') {
                flagImgSrc = `/cdn/shop/files/${language.replace(/[^a-z0-9\-]/g, '')}.png`;
              } else if (language.includes('norsk')) {
                flagImgSrc = `/cdn/shop/files/norsk.png`;
              } else if (language == 'kinesisk') {
                flagImgSrc = `/cdn/shop/files/china.svg`;
              } else {
                flagImgSrc = `/cdn/shop/files/${language.replace(/[^a-z0-9\-]/g, '')}.svg`;
              }
            }
          }
        }
        let bindingTypeLabel = bindingType;
        if (window.relewiseAPI.pim_binding_type_mapping && window.relewiseAPI.pim_binding_type_mapping.length > 0) {
          let bindingTypeItem = window.relewiseAPI.pim_binding_type_mapping.find(item => {
            let itemParts = item.split(':');
            return itemParts[0].toLowerCase().trim() == bindingType.toLowerCase().trim();
          });
          if (bindingTypeItem) {
            bindingTypeLabel = bindingTypeItem.split(':')[1].trim();
          }
        }
        bottomBadgesHtml += `<div class="product-card__binding-type-badge">
          <span class="badge badge--binding-type ${flagImgSrc ? 'badge--has-flag' : ''}" ${flagImgSrc ? `style="background-image: url(${flagImgSrc})"` : ''}>${bindingTypeLabel}</span></div>`;
      }
    }
    productSkeleton.querySelector('.rpc-badges').innerHTML = bottomBadgesHtml;

    if (window.themeVariables.ir.product.showSoldOutBadge && product.data['IsAvailable'] && product.data['IsAvailable'].value == false) {
      productSkeleton.querySelector('.product-card__badge-list').innerHTML = `<sold-out-badge class="badge badge--sold-out">
          ${window.themeVariables.ir.product.soldOutBadgeText}
        </sold-out-badge>`;
    } else {
      if (product.salesPrice && product.listPrice && product.listPrice > product.salesPrice) {
        productSkeleton.querySelector('.product-card__badge-list').innerHTML = `<on-sale-badge class="badge badge--on-sale">
          ${window.themeVariables.ir.product.discountBadgeText}
        </on-sale-badge>`;
      }
    }
    // also add pricetag badges into .product-card__badge-list. JS logic should follow exactly same as in snippets/pricetag-badges.liquid
    // badges in product data is from product.data[`${window.relewiseAPI.relewise_prefix_data}_pim.badges`].value.values
    if (product.data[`${window.relewiseAPI.relewise_prefix_data}_pim.badges`] && product.data[`${window.relewiseAPI.relewise_prefix_data}_pim.badges`].value) {
      let badges = product.data[`${window.relewiseAPI.relewise_prefix_data}_pim.badges`].value.$values;
      // -- Render pricetag badges by mapping badge keys to labels, deduplicating, and supporting combo badges like pricetag-badges.liquid
      if (window.badgeSettings && window.badgeSettings.pricetag_badges_enabled && Array.isArray(badges) && badges.length > 0) {
        const ptKeyLines = window.badgeSettings.pt_key_lines || [];
        const ptSep = '|||';
        let allLabels = [];
        let allLabelsLower = [];
        // for each badge key
        badges.forEach(badgeKey => {
          const ptKeyUpper = typeof badgeKey === 'string' ? badgeKey.toUpperCase().trim() : '';
          ptKeyLines.forEach(line => {
            const ptLine = (line || '').trim();
            if (!ptLine) return;
            const ptKV = ptLine.split(':');
            const ptMapKey = ptKV[0] ? ptKV[0].toUpperCase().trim() : '';
            if (ptKeyUpper === ptMapKey) {
              // map found: get badge label(s)
              const ptBadgeStr = ptLine.substring(ptKV[0].length + 1).trim();
              const ptBadgeItems = ptBadgeStr.split('|');
              ptBadgeItems.forEach(ptLabel => {
                ptLabel = ptLabel.trim();
                if (!ptLabel) return;
                const ptLabelLower = ptLabel.toLowerCase();
                // deduplicate using lower-case search and separator
                if (allLabelsLower.indexOf(ptSep+ptLabelLower+ptSep) === -1 && !allLabelsLower.includes(ptLabelLower)) {
                  allLabels.push(ptLabel);
                  allLabelsLower.push(ptLabelLower);
                }
              });
            }
          });
        });
        // render if any found
        if (allLabels.length > 0) {
          // Render pricetag badges following the Liquid logic from snippets/pricetag-badges.liquid (overlay mode)
          const ptStyleLines = window.badgeSettings.pricetag_badge_styles || [];
          // const placement = 'overlay'; // we're only rendering the overlay (all badges, all styles)

          // Helper to resolve badge style for a label
          function getBadgeStyle(label, ptStyleLines) {
            let style = 'header';
            const bl = label.toLowerCase().trim();
            for (const sl of ptStyleLines) {
              const ptSl = (sl || '').trim();
              if (!ptSl) continue;
              const ptSv = ptSl.split(':');
              const ptSlLabel = ptSv[0] ? ptSv[0].toLowerCase().trim() : '';
              if (bl === ptSlLabel) {
                style = ptSv.length > 1 ? ptSv[ptSv.length - 1].trim().toLowerCase() : 'header';
                break;
              }
            }
            return style;
          }

          let badgeTruncate = window.badgeSettings.pricetag_badge_truncate;
          let darkOutput = '';
          let pinkOutput = '';

          allLabels.forEach((label) => {
            let style = getBadgeStyle(label, ptStyleLines);
            let truncateLimit = badgeTruncate;
            let labelContent = label;
            let needsTruncate = false;

            if (
              window.badgeSettings &&
              window.badgeSettings.pricetag_badges_enabled &&
              typeof truncateLimit === 'number' &&
              truncateLimit > 0 &&
              label.length > truncateLimit
            ) {
              labelContent = label.substring(0, truncateLimit) + '...';
              needsTruncate = true;
            }

            let spanAttrs = `class="badge badge--pricetag badge--pricetag-${style}"`;
            let spanTitle = needsTruncate
              ? ` title="${label.replace(/"/g, '&quot;')}"`
              : '';
            let badgeHtml = `<span ${spanAttrs}${spanTitle}>${labelContent}</span>`;

            // Validate against duplicated badge
            const lowerLabel = label.toLowerCase().trim();
            const badgeExistsInOutput = (output) =>
              output
                .replace(/<[^>]+>/g, ' ') // remove html tags for searching
                .toLowerCase()
                .includes(lowerLabel);

            if (style === 'price' || style === 'header-dark') {
              if (!badgeExistsInOutput(darkOutput)) {
                darkOutput += badgeHtml;
              }
            } else {
              if (!badgeExistsInOutput(pinkOutput)) {
                pinkOutput += badgeHtml;
              }
            }
          });

          // Combine overlay output (all badges regardless of style, order is dark then pink)
          productSkeleton.querySelector('.product-card__badge-list').innerHTML += darkOutput + pinkOutput;
        }
      }
    }

    // Location badge: Relewise returns custom.kobslogik as a Metaobject GID only,
    // so resolve the badge text from window.kobslogikMetaobjects (populated by snippets/relewise.liquid).
    if (window.relewiseAPI.location_badge_enabled && window.kobslogikMetaobjects) {
      const kobslogikData = product.data[`${window.relewiseAPI.relewise_prefix_data}_custom.kobslogik`];
      const kobslogikGid = kobslogikData && kobslogikData.value;
      if (typeof kobslogikGid === 'string' && kobslogikGid) {
        const kobslogikEntry = window.kobslogikMetaobjects[kobslogikGid];
        const locationBadgeText = kobslogikEntry && kobslogikEntry.klik_og_hent_badge;
        if (locationBadgeText && locationBadgeText.trim().toLowerCase() !== 'ingen badge') {
          const formattedBadgeText = locationBadgeText.charAt(0).toUpperCase() + locationBadgeText.slice(1).toLowerCase();
          productSkeleton.querySelector('.product-card__badge-list').innerHTML +=
            `<span class="product-card__badge-break"></span><span class="badge badge--kun-online">${escapeHtml(formattedBadgeText)}</span>`;
        }
      }
    }

    // reviews from judge.me metafield
    const reviewDataKey = `${window.relewiseAPI.relewise_prefix_data}_judgeme.review_widget_data`;
    if (product.data[reviewDataKey] && product.data[reviewDataKey].value) {
      productSkeleton.querySelector('.rpc-reviews').innerHTML = buildJudgeMeBadgeHtml(product.data[reviewDataKey].value);
    }
  }
  // productSkeleton.querySelector('.rpc-reviews').innerHTML = product.reviews;
  if (window.relewiseAPI.remove_product_white_background) {
    let removeBgClass = 'remove-background';
    let tags = product?.data?.Tags?.value?.$values;
    if (Array.isArray(tags) &&
        tags.length > 0 &&
        tags.some(t => typeof t === 'string' && t.toLowerCase().includes('#background'))
    ) {
      removeBgClass = '';
    }
    if (product.data[`${window.relewiseAPI.relewise_prefix_data}_pim.book`] && product.data[`${window.relewiseAPI.relewise_prefix_data}_pim.book`].value) {
      removeBgClass = '';
    }
    if (removeBgClass) {
      productSkeleton.classList.add(removeBgClass);
    }
  }

  return productSkeleton;
}

function buildJudgeMeBadgeHtml(jsonString) {
  try {
    const data = JSON.parse(jsonString);
    const avgRating = parseFloat(data.average_rating) || 0;
    if (avgRating <= 0) return '';
    const numReviews = parseInt(data.number_of_reviews) || 0;
    const numQuestions = parseInt(data.number_of_questions) || 0;

    const stars = [];
    for (let i = 1; i <= 5; i++) {
      if (avgRating >= i) {
        stars.push("<span class='jdgm-star jdgm--on'></span>");
      } else if (avgRating >= i - 0.5) {
        stars.push("<span class='jdgm-star jdgm--half'></span>");
      } else {
        stars.push("<span class='jdgm-star jdgm--off'></span>");
      }
    }

    return `<div class='jdgm-prev-badge' data-average-rating='${avgRating.toFixed(2)}' data-number-of-reviews='${numReviews}' data-number-of-questions='${numQuestions}'>` +
      `<span class='jdgm-prev-badge__stars' data-score='${avgRating.toFixed(2)}' tabindex='0' aria-label='${avgRating.toFixed(2)} stars' role='button'>` +
      stars.join('') +
      `</span>` +
      `</div>`;
  } catch (e) {
    return '';
  }
}

function getProductHandle(product) {
  const pHandleData = product.data && product.data[`${window.relewiseAPI.relewise_prefix_data}_ShopifyHandle`];
  return pHandleData && pHandleData.value ? pHandleData.value : '';
}

function getProductUrl(product) {
  const productHandle = getProductHandle(product);
  return productHandle ? `/products/${productHandle}` : '#';
}

function getProductVariantId(product) {
  return product.variant && product.variant.data && product.variant.data[`${window.relewiseAPI.relewise_prefix_data}_ShopifyVariantId`]
    ? product.variant.data[`${window.relewiseAPI.relewise_prefix_data}_ShopifyVariantId`].value
    : undefined;
}

function getProductImageHtml(product, imageClass, width) {
  const imageUrlsData = product.data && product.data[`${window.relewiseAPI.relewise_prefix_data}_ImageUrls`];
  const fallbackImage = window.themeVariables.ir.product.fallbackImage;
  const imageUrl = imageUrlsData?.value?.$values?.[0] || fallbackImage;
  const productUrl = getProductUrl(product);
  const productTitle = escapeHtml(product.displayName || '');

  return `<a href="${escapeHtml(productUrl)}" title="${productTitle}" class="block">
    <img class="${imageClass}" src="${escapeHtml(imageUrl)}" loading="lazy" alt="${productTitle}" width="${width}">
  </a>`;
}

function getProductPriceHtml(product) {
  const isPriceZero = window.themeVariables?.settings?.hideZeroPrice && product.salesPrice === 0;
  const tags = product?.data?.Tags?.value?.$values;
  const hasCampaignTag = Array.isArray(tags) && tags.some(t => typeof t === 'string' && t.toLowerCase().startsWith('campaign'));
  const isOnSale = (product.listPrice && product.listPrice > product.salesPrice) || hasCampaignTag;

  let priceHtml = `<div class="rl-product-prices h-stack gap-2"${isPriceZero ? ' style="display:none"' : ''}>`;
  if (product.salesPrice || product.salesPrice === 0) {
    priceHtml += `<span class="rl-product-price ${isOnSale ? 'text-on-sale' : ''}">${Shopify.formatMoney(product.salesPrice * 100)}</span>`;
  }
  if (product.listPrice && product.listPrice > product.salesPrice) {
    priceHtml += `<span class="rl-product-price-old line-through">${Shopify.formatMoney(product.listPrice * 100)}</span>`;
  }
  priceHtml += '</div>';

  return priceHtml;
}

function buildHorizontalProductHtml(product) {
  const productHandle = getProductHandle(product);
  const productUrl = getProductUrl(product);
  const productTitle = escapeHtml(product.displayName || '');
  const variantId = getProductVariantId(product);
  const isPriceZero = window.themeVariables?.settings?.hideZeroPrice && product.salesPrice === 0;
  const isAvailable = product.data?.IsAvailable?.value === true;
  const card = document.createElement('div');

  card.className = 'horizontal-product snap-start rounded-xs bg-custom';
  card.setAttribute('style', '--background: 242 242 242;');
  if (productHandle) {
    card.dataset.productHandle = productHandle;
  }

  if (window.relewiseAPI.remove_product_white_background) {
    const tags = product?.data?.Tags?.value?.$values;
    const hasForcedBackground = Array.isArray(tags) && tags.some(t => typeof t === 'string' && t.toLowerCase().includes('#background'));
    const hasBookData = Boolean(product.data?.[`${window.relewiseAPI.relewise_prefix_data}_pim.book`]?.value);

    if (!hasForcedBackground && !hasBookData) {
      card.classList.add('remove-background', 'bg-custom');
    }
  }

  let quickBuyHtml = '';
  if (variantId && isAvailable) {
    quickBuyHtml = `<div class="horizontal-product__cta"${isPriceZero ? ' style="display:none"' : ''}>
      <form method="post" action="/cart/add" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data" is="product-form">
        <input type="hidden" name="form_type" value="product">
        <input type="hidden" name="utf8" value="✓">
        <input type="hidden" name="quantity" value="1">
        <input type="hidden" name="id" value="${escapeHtml(String(variantId))}">
        <button type="submit" is="custom-button" class="horizontal-product__quick-buy-button" aria-label="+ Hurtig tilføjelse">
          <div>
            <svg role="presentation" focusable="false" width="50" height="50" class="icon icon-quick-buy-cart" viewBox="0 0 100 100">
              <circle cx="50" cy="50" r="45" fill="#e52424"></circle><path stroke="#fff" stroke-linecap="round" stroke-width="4" d="M68 18v16M60 26h16"></path><path fill="none" stroke="#fff" stroke-linecap="round" stroke-width="4" d="M38 46a12 12 0 0 1 24 0"></path><path fill="none" stroke="#fff" stroke-linejoin="round" stroke-width="4" d="M30 46h40l-6 26H36Z"></path>
            </svg>
          </div>
          <span class="button__loader">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
        <input type="hidden" name="product-id" value="${escapeHtml(String(product.productId || ''))}">
      </form>
    </div>`;
  }

  card.innerHTML = `
    ${getProductImageHtml(product, 'horizontal-product__image rounded-xs', 160)}
    <div class="horizontal-product__info">
      <div class="v-stack gap-0.5">
        <a href="${escapeHtml(productUrl)}" data-instant class="text-sm bold">
          <span class="reversed-link hover:show">${productTitle}</span>
        </a>
        ${getProductPriceHtml(product)}
      </div>
      ${quickBuyHtml}
    </div>`;

  return card;
}

function getCartDrawerRecommendationProducts(wrapper) {
  const container = wrapper.closest('.cart-drawer__recommendations');
  const productsJson = container?.querySelector('.relewise-cart-drawer-products')?.textContent;

  if (!productsJson) {
    return [];
  }

  try {
    const products = JSON.parse(productsJson);
    return Array.isArray(products)
      ? products.filter(product => product?.productId).map(product => ({
          productId: String(product.productId),
          variantId: product.variantId ? String(product.variantId) : undefined
        }))
      : [];
  } catch (error) {
    console.error('Failed to parse cart drawer Relewise products:', error);
    return [];
  }
}

async function fetchCartDrawerRecommendationProducts(wrapper) {
  const cartProducts = getCartDrawerRecommendationProducts(wrapper);

  if (!cartProducts.length) {
    return undefined;
  }

  const settings = {
    language: `${window.themeVariables.settings.languages}`,
    currency: `${window.themeVariables.settings.shopCurrency}`,
    displayedAtLocation: 'Cart drawer',
    user: getUserData()
  };
  const builder = new Relewise.PurchasedWithMultipleProductsBuilder(settings)
    .setSelectedProductProperties({
      displayName: true,
      dataKeys: PRODUCT_DATA_KEYS,
      pricing: true
    })
    .setSelectedVariantProperties({ dataKeys: [`${prefixData}_ShopifyVariantId`] })
    .addProducts(cartProducts)
    .setNumberOfRecommendations(Number(wrapper.dataset.productsCount) || 10);

  const recommender = new Relewise.Recommender(window.relewiseAPI.relewise_dataid, window.relewiseAPI.relewise_api, {
    serverUrl: window.relewiseAPI.relewise_server_url,
  });

  return recommender.recommendPurchasedWithMultipleProducts(builder.build());
}

function reinitCartDrawerCarousel(wrapper) {
  const scrollCarousel = wrapper.closest('scroll-carousel');
  if (!scrollCarousel) {
    return;
  }

  const parent = scrollCarousel.parentNode;
  const nextSibling = scrollCarousel.nextSibling;

  // Force a fresh disconnect/connect lifecycle so BaseCarousel re-evaluates items.length
  // and binds the control:prev/control:next listeners with the loaded products in place.
  parent.removeChild(scrollCarousel);
  scrollCarousel._items = undefined;
  scrollCarousel._selectedIndex = undefined;
  parent.insertBefore(scrollCarousel, nextSibling);

  // Reconnect each prev/next button so it re-binds scroll:edge-nearing listeners on the
  // (now-initialised) scroll area and reflects the correct disabled state.
  const controls = scrollCarousel
    .closest('.cart-drawer__recommendations')
    ?.querySelector('[data-relewise-cart-drawer-controls]');

  controls?.querySelectorAll('button[is="prev-button"], button[is="next-button"]').forEach(button => {
    const placeholder = document.createComment('relewise-cart-drawer-button-anchor');
    button.replaceWith(placeholder);
    placeholder.replaceWith(button);
  });
}

function fetchAndRenderCartDrawerRecommendations() {
  if (!window.Relewise) {
    return;
  }

  document.querySelectorAll('.relewise-cart-drawer-recommendation-wrapper').forEach(wrapper => {
    const container = wrapper.closest('.cart-drawer__recommendations');
    const header = container?.querySelector('[data-relewise-cart-drawer-header]');
    const controls = container?.querySelector('[data-relewise-cart-drawer-controls]');
    const cartProducts = getCartDrawerRecommendationProducts(wrapper);
    const cartProductIds = new Set(cartProducts.map(product => product.productId));

    if (!container || !cartProducts.length) {
      return;
    }

    wrapper.classList.add('is-loading');
    fetchCartDrawerRecommendationProducts(wrapper).then((data) => {
      const products = (data?.recommendations || []).filter(product => !cartProductIds.has(String(product.productId)));

      if (!products.length) {
        container.hidden = true;
        return;
      }

      wrapper.innerHTML = '';
      products.forEach(product => {
        wrapper.appendChild(buildHorizontalProductHtml(product));
      });

      wrapper.classList.remove('is-loading');

      container.hidden = false;
      if (header) {
        header.hidden = false;
      }
      if (controls) {
        controls.hidden = products.length <= 1;
      }

      reinitCartDrawerCarousel(wrapper);
    }).catch((error) => {
      console.error('Cart drawer Relewise recommendations error:', error);
      container.hidden = true;
    }).finally(() => {
      wrapper.classList.remove('is-loading');
    });
  });
}

// collection page
function getItemCollectionPage(collectionId, productPerPage, page, sorting = '', facets = {}) {
  window.currentPage = parseInt(page);
  const settings = {
    language: `${window.themeVariables.settings.languages}`,
    currency: `${window.themeVariables.settings.shopCurrency}`,
    displayedAtLocation: 'Category page',
    user: getUserData()
  };
  const builder = new Relewise.SearchCollectionBuilder(settings)
    .addRequest(new Relewise.ProductSearchBuilder(settings)
      .setSelectedProductProperties({
        displayName: true,
        dataKeys: PRODUCT_DATA_KEYS,
        pricing: true
      })
      .setSelectedVariantProperties({ dataKeys: [`${prefixData}_ShopifyVariantId`] })
      .setExplodedVariants(1)
      .setRetailMedia(new Relewise.RetailMediaQueryBuilder(settings)
        .setLocation({
          key: 'PRODUCT_LISTING_PAGE',
          variation: {
            key: 'DESKTOP'
          },
          placements: [
            { key: 'FIRST_SPOT' },
            { key: 'SECOND_SPOT' },
            { key: 'THIRD_SPOT' },
            { key: 'FOURTH_SPOT' },
            { key: 'FIFTH_SPOT' },
            { key: 'SIXTH_SPOT' },
            { key: 'SEVENTH_SPOT' },
            { key: 'EIGHTH_SPOT' },
            { key: 'NINTH_SPOT' },
            { key: 'TENTH_SPOT' }
          ]
        })
        .setSelectedDisplayAdProperties({
          allData: true
        })
        .build()
      )
      .filters(f => f
        .addProductCategoryIdFilter('ImmediateParent', [collectionId])
      )
      .facets((f) => {
        if (facets.hasOwnProperty(`${prefixData}_pim.number_of_participants`)) {
          f.addProductDataStringValueFacet(`${prefixData}_pim.number_of_participants`, 'Product', facets[`${prefixData}_pim.number_of_participants`])
        } else {
          f.addProductDataStringValueFacet(`${prefixData}_pim.number_of_participants`)
        }
        if (facets.hasOwnProperty(`${prefixData}_pim.age`)) {
          f.addProductDataStringValueFacet(`${prefixData}_pim.age`, 'Product', facets[`${prefixData}_pim.age`])
        } else {
          f.addProductDataStringValueFacet(`${prefixData}_pim.age`)
        }
        if (facets.hasOwnProperty(`${prefixData}_pim.publisher`)) {
          f.addProductDataStringValueFacet(`${prefixData}_pim.publisher`, 'Product', facets[`${prefixData}_pim.publisher`])
        } else {
          f.addProductDataStringValueFacet(`${prefixData}_pim.publisher`)
        }
        if (facets.hasOwnProperty(`${prefixData}_pim.series_name_reference`)) {
          f.addProductDataStringValueFacet(`${prefixData}_pim.series_name_reference`, 'Product', facets[`${prefixData}_pim.series_name_reference`])
        } else {
          f.addProductDataStringValueFacet(`${prefixData}_pim.series_name_reference`)
        }
        if (facets.hasOwnProperty(`${prefixData}_pim.author`)) {
          f.addProductDataStringValueFacet(`${prefixData}_pim.author`, 'Product',facets[`${prefixData}_pim.author`])
        } else {
          f.addProductDataStringValueFacet(`${prefixData}_pim.author`)
        }
        if (facets.hasOwnProperty(`${prefixData}_pim.brand`)) {
          f.addProductDataStringValueFacet(`${prefixData}_pim.brand`, 'Product', facets[`${prefixData}_pim.brand`])
        } else {
          f.addProductDataStringValueFacet(`${prefixData}_pim.brand`)
        }
        if (facets.hasOwnProperty('filter.v.price.gte') || facets.hasOwnProperty('filter.v.price.lte')) {
          f.addSalesPriceRangeFacet('Product', facets['filter.v.price.gte'] || null, facets['filter.v.price.lte'] || null);
        } else {
          f.addSalesPriceRangeFacet();
        }
        if (facets.hasOwnProperty(`${prefixData}_pim.global_binding`)) {
          f.addProductDataStringValueFacet(`${prefixData}_pim.global_binding`, 'Product', facets[`${prefixData}_pim.global_binding`])
        } else {
          f.addProductDataStringValueFacet(`${prefixData}_pim.global_binding`)
        }
        if (facets.hasOwnProperty(`${prefixData}_pim.language`)) {
          f.addProductDataStringValueFacet(`${prefixData}_pim.language`, 'Product', facets[`${prefixData}_pim.language`])
        } else {
          f.addProductDataStringValueFacet(`${prefixData}_pim.language`)
        }
        if (facets.hasOwnProperty(`${prefixData}_pim.purchasing_group`)) {
          f.addProductDataStringValueFacet(`${prefixData}_pim.purchasing_group`, 'Product', facets[`${prefixData}_pim.purchasing_group`])
        } else {
          f.addProductDataStringValueFacet(`${prefixData}_pim.purchasing_group`)
        }
      })
      .pagination(p => p
          .setPageSize(productPerPage)
          .setPage(page))
      .sorting((s) => {
        switch (sorting) {
          case 'title-ascending':
            s.sortByProductAttribute('DisplayName', 'Ascending', (n) => n.sortByProductRelevance())
            break;
          case 'title-descending':
            s.sortByProductAttribute('DisplayName', 'Descending', (n) => n.sortByProductRelevance())
            break;
          case 'price-ascending':
            s.sortByProductAttribute('SalesPrice', 'Ascending', (n) => n.sortByProductRelevance())
            break;
          case 'price-descending':
            s.sortByProductAttribute('SalesPrice', 'Descending', (n) => n.sortByProductRelevance())
            break;
          case 'created-descending':
            s.sortByProductData(`${prefixData}_pim.publication_date_timestamp`, 'Product', 'Descending', (n) => n.sortByProductRelevance())
            break;
          case 'best-selling':
            s.sortByProductPopularity('Descending', (n) => n.sortByProductRelevance())
            break;
          default:
            s.sortByProductData('InStock', 'Product', 'Descending', (n) => n.sortByProductRelevance())
            break;
        }
      })
      .build());

  const searcher = new Relewise.Searcher(window.relewiseAPI.relewise_dataid, window.relewiseAPI.relewise_api, {
    serverUrl: window.relewiseAPI.relewise_server_url,
  });
  return searcher.batch(builder.build())
}

function renderCollectionFromRelewise(data) {
  let products = [];
  let paginationElement = document.querySelector('.collection__pagination-relewise');
  let hits = 0;
  if (data && data.responses && data.responses.length > 0) {
    products = data.responses[0].results;
    hits = data.responses[0].hits;
    document.querySelector('.rlw-product-count').textContent = window.themeVariables.ir.collection.product_count.replace('[count]', hits);
    // console.log(products, hits);
    let productsWrapper = document.querySelector('.relewise-collection-page-wrapper .product-list');
    if (products.length) {
      productsWrapper.innerHTML = '';
      products.forEach(product => {
        let productSkeleton = buildProductCardHtml(product);
        productsWrapper.appendChild(productSkeleton);
      });

      let productPerPage = document.querySelector('input[name="collection_id"]').dataset.productperpage;
      let numberOfPages = Math.ceil(hits / productPerPage);
      if (numberOfPages > 1) {
        paginationElement.classList.remove('hidden');
        paginationElement.querySelector('.pagination__current').textContent = `${window.currentPage} / ${numberOfPages}`;
        if (window.currentPage <= 1) {
          paginationElement.querySelector('.pagination__item[rel="prev"]').classList.add('pagination__item--disabled');
        } else {
          paginationElement.querySelector('.pagination__item[rel="prev"]').classList.remove('pagination__item--disabled');
        }
        if (window.currentPage >= numberOfPages) {
          paginationElement.querySelector('.pagination__item[rel="next"]').classList.add('pagination__item--disabled');
        } else {
          paginationElement.querySelector('.pagination__item[rel="next"]').classList.remove('pagination__item--disabled');
        }
      } else {
        paginationElement.classList.add('hidden');
      }
    } else {
      productsWrapper.innerHTML = `<div class="text-sm text-subdued">${window.themeVariables.ir.search.noProductsFound}</div>`;
      paginationElement.classList.add('hidden');
    }
    renderRetailMedia(data);
    renderCollectionPromotions();
    renderCollectionFacets(data);

    // align height of product cards
    window.alignHeight('.product-card .rpc-author', productsWrapper);
    productsWrapper.classList.remove('is-loading');
  }
}

function renderCollectionFacets(data, wrapperSelector = '.relewise-collection-page-wrapper') {
  let facetsWrapper = document.querySelector('#facet-form');
  document.querySelectorAll('#facet-form > .accordion:not(#accordion-sort-by)').forEach(item => {
    item.remove();
  });
  document.querySelectorAll(`${wrapperSelector} .active-facets`)?.forEach(item => {
    item.remove();
  });
  if (data && data.responses && data.responses.length) {
    let facets = data.responses[0].facets;
    if (facets && facets.items && facets.items.length) {
      let activeFacetsHtml = '';
      window.activeFacets = window.activeFacets || {};
      facets.items.forEach(facet => {
        if (Array.isArray(facet.available) && facet.available.length == 0 && (!facet.selected || facet.selected.length == 0)) {
          return;
        }
        let facetHtml = `<details class=" accordion  group" aria-expanded="false" is="accordion-disclosure" data-key="${facet.key ? facet.key : 'rlw-facet-' + facet.field}">
            <summary>
              <div class="accordion__toggle bold">
                <span class="facet-name">[facet_name_placeholder]</span>
                <span class="facet-active-count [count_class_placeholder]">[facet_active_count_placeholder]</span>
                <span class="circle-chevron group-hover:colors group-expanded:colors group-expanded:rotate">
                  <svg role="presentation" focusable="false" width="8" height="6" class="icon icon-chevron-bottom-small" viewBox="0 0 8 6">
                  <path d="m1 1.5 3 3 3-3" fill="none" stroke="currentColor" stroke-width="1.5"></path>
                </svg></span>
              </div>
            </summary>

            <div class="accordion__content">[facet_content_placeholder]</div>
          </details>`;
        if (facet.$type.indexOf('PriceRangeFacetResult') !== -1) {
          // let lowerBound = facet.available.value.lowerBoundInclusive;
          let upperBound = Math.ceil(facet.available.value.upperBoundInclusive);
          let currentLowerBound = facet.selected?.lowerBoundInclusive || 0;
          let currentUpperBound = facet.selected?.upperBoundInclusive || upperBound;
          if (facet.selected && (facet.selected?.lowerBoundInclusive || facet.selected?.upperBoundInclusive)) {
            activeFacetsHtml += `<div class="removable-facet">
                <span class="facet-name">${Shopify.formatMoney(currentLowerBound * 100)} - ${Shopify.formatMoney(currentUpperBound * 100)}</span>
                <a href="#" class="tap-area" data-facet-key="price"><svg role="presentation" stroke-width="2" focusable="false" width="10" height="10" class="icon icon-delete" viewBox="0 0 10 10">
                    <path d="m.757.757 8.486 8.486m-8.486 0L9.243.757" stroke="currentColor"></path>
                  </svg></a>
                </div>`;
            window.activeFacets['filter.v.price.lte'] = currentUpperBound;
            window.activeFacets['filter.v.price.gte'] = currentLowerBound;
            facetHtml = facetHtml.replace('[facet_active_count_placeholder]', '1');
            facetHtml = facetHtml.replace('[count_class_placeholder]', '');
          } else {
            facetHtml = facetHtml.replace('[count_class_placeholder]', 'hidden');
          }
          let priceRangeHtml = `<price-range class="price-range ">
            <div class="range-group" style="--range-min: 0.0%; --range-max: 99.98333333333333%">
              <input type="range" aria-label="" class="range" min="0" max="${upperBound}" value="${currentLowerBound}">
              <input type="range" aria-label="" class="range" min="0" max="${upperBound}" value="${currentUpperBound}">
            </div>
            <div class="input-group">
              <label class="input-prefix text-sm">
                <span class="prefix text-subdued">${Shopify.money_format_relewise}</span>
                <input aria-label="" class="field" type="number" inputmode="numeric" name="filter.v.price.gte" id="filter.v.price.gte" min="0" max="${upperBound}" placeholder="0" autocomplete="off" ${currentLowerBound > 0 ? 'value="' + currentLowerBound + '"' : ''}>
              </label>
              <span class="text-subdued text-sm">til</span>
              <label class="input-prefix text-sm">
                <span class="prefix text-subdued">${Shopify.money_format_relewise}</span>
                <input aria-label="" class="field" type="number" inputmode="numeric" name="filter.v.price.lte" id="filter.v.price.lte" min="0" max="${upperBound}" placeholder="${upperBound}" autocomplete="off" ${currentUpperBound < upperBound ? 'value="' + currentUpperBound + '"' : ''}>
              </label>
            </div></price-range>`;
          facetHtml = facetHtml.replace('[facet_content_placeholder]', priceRangeHtml);
          facetHtml = facetHtml.replace('[facet_name_placeholder]', window.themeVariables.ir.collection.price);
        } else if (facet.$type.indexOf('ProductDataStringValueFacetResult') !== -1) {
          sortFacetOptions(facet);
          let facetName = facet.key
          if (facet.key == `${prefixData}_pim.author`) {
            facetName = window.themeVariables.ir.collection.author;
          } else if (facet.key == `${prefixData}_pim.global_binding`) {
            facetName = window.themeVariables.ir.collection.binding_type;
          } else if (facet.key == `${prefixData}_pim.purchasing_group`) {
            facetName = window.themeVariables.ir.collection.purchasing_group;
          } else if (facet.key == `${prefixData}_pim.language`) {
            facetName = window.themeVariables.ir.collection.language;
          } else if (facet.key == `${prefixData}_pim.series_name_reference`) {
            facetName = window.themeVariables.ir.collection.series_name_reference;
          } else if (facet.key == `${prefixData}_pim.publisher`) {
            facetName = window.themeVariables.ir.collection.publisher;
          } else if (facet.key == `${prefixData}_pim.brand`) {
            facetName = window.themeVariables.ir.collection.brand;
          } else if (facet.key == `${prefixData}_pim.age`) {
            facetName = window.themeVariables.ir.collection.age;
          } else if (facet.key == `${prefixData}_pim.number_of_participants`) {
            facetName = window.themeVariables.ir.collection.number_of_participants;
          }
          facetHtml = facetHtml.replace('[facet_name_placeholder]', facetName);

          let maxiMumLength = 10;
          let checkboxListHtml = ``;
          facet.selected?.forEach(selected => {
            let option = facet.available.find(option => option.value == selected);
            let hits = option ? option.hits : 0;
            let label = renderLabel(selected, facet.key);
            checkboxListHtml += `<div class="checkbox-container">
              <input type="checkbox" class="checkbox" name="rlw-${facet.key}" value="${selected}" id="${facet.key}-${selected}" checked>
              <label for="${facet.key}-${selected}">${label} (${hits})</label>
            </div>`;
          });
          facet.available.slice(0, maxiMumLength).forEach(option => {
            if (facet.selected && facet.selected.includes(option.value)) {
              return;
            }
            let label = renderLabel(option.value, facet.key);
            checkboxListHtml += `<div class="checkbox-container">
              <input type="checkbox" class="checkbox" name="rlw-${facet.key}" value="${option.value}" id="${facet.key}-${option.value}" ${option.selected ? 'checked' : ''}>
              <label for="${facet.key}-${option.value}">${label} (${option.hits})</label>
            </div>`;
          });
          if (facet.available.length > maxiMumLength) {
            window.relewiseFacets = window.relewiseFacets || {};
            window.relewiseFacets[facet.key] = facet.available;
            checkboxListHtml = `<div class="checkbox-container rlw-facet-search-container">
              <input type="text" class="input rlw-facet-search" name="search-${facet.key}" data-key="${facet.key}" value="" placeholder="Search...">
            </div><div class="checkbox-list">${checkboxListHtml}</div>`;
          } else {
            checkboxListHtml = `<div class="checkbox-list">${checkboxListHtml}</div>`;
          }
          facetHtml = facetHtml.replace('[facet_content_placeholder]', checkboxListHtml);

          if (facet.selected && facet.selected.length) {
            facet.selected.forEach(selected => {
              let label = renderLabel(selected, facet.key);
              activeFacetsHtml += `<div class="removable-facet">
                <span class="facet-name">${label}</span>
                <a href="#" class="tap-area" data-facet-key="${facet.key}" data-facet-value="${selected}"><svg role="presentation" stroke-width="2" focusable="false" width="10" height="10" class="icon icon-delete" viewBox="0 0 10 10">
                    <path d="m.757.757 8.486 8.486m-8.486 0L9.243.757" stroke="currentColor"></path>
                  </svg></a>
                </div>`;
              if (!window.activeFacets[facet.key]) {
                window.activeFacets[facet.key] = [];
              }
              if (!window.activeFacets[facet.key].includes(selected)) {
                window.activeFacets[facet.key].push(selected);
              }
            });
            facetHtml = facetHtml.replace('[facet_active_count_placeholder]', facet.selected.length);
            facetHtml = facetHtml.replace('[count_class_placeholder]', '');
          } else {
            facetHtml = facetHtml.replace('[count_class_placeholder]', 'hidden');
          }
        }
        facetsWrapper.innerHTML = facetHtml + facetsWrapper.innerHTML;
      });
      if (activeFacetsHtml) {
        let activeFacetsCount = Object.values(window.activeFacets).reduce((count, arr) => count + arr.length, 0);
        if (activeFacetsCount > 1) {
          activeFacetsHtml += `<a href="#" class="rlw-facet-clear-all facet-clear-all text-subdued">
            <span class="link">${window.themeVariables.ir.collection.clear_all_filters}</span>
          </a>`;
        }
        document.querySelectorAll(`${wrapperSelector} .active-facets-wrapper`).forEach(item => {
          item.innerHTML = `<div class="active-facets">${activeFacetsHtml}</div>`;
        });
      }
    }
  }

  if (document.querySelector('.relewise-sort')) {
    let currentSortingText = document.querySelector(`.relewise-sort #relewise-collection-sort .popover-listbox__option:first-child .reversed-link`).textContent;
    let currentSortingElement = document.querySelector(`.relewise-sort #relewise-collection-sort .popover-listbox__option[value="${window.currentSorting}"] .reversed-link`);
    if (currentSortingElement) {
      currentSortingText = currentSortingElement.textContent;
    }
    document.querySelector('.relewise-sort #relewise-collection-sort-value').textContent = currentSortingText;
  }
  if (document.querySelector('.rlw-drawer-sort-by')) {
    if (window.currentSorting) {
      document.querySelector(`.rlw-drawer-sort-by .checkbox-list input[name="sort_by"][value="${window.currentSorting}"]`).checked = true;
    } else {
      if (document.querySelector(`.rlw-drawer-sort-by .checkbox-list input[name="sort_by"][value="manual"]`)) {
        document.querySelector(`.rlw-drawer-sort-by .checkbox-list input[name="sort_by"][value="manual"]`).checked = true;
      }
    }
  }
}

// helper
window.alignHeight = function(selector, container) {
  const elements = Array.from(container.querySelectorAll(selector));
  if (!elements.length) return;

  elements.forEach(element => {
    element.style.height = 'auto';
  });

  const positioned = elements.map(element => {
    const card = element.closest('.product-card');
    const { top } = (card || element).getBoundingClientRect();
    return { element, top: Math.round(top) };
  }).sort((a, b) => a.top - b.top);

  let currentRowTop = null;
  let currentRow = [];
  const rows = [];

  for (const item of positioned) {
    if (currentRowTop === null || Math.abs(item.top - currentRowTop) <= 1) {
      currentRowTop = currentRowTop === null ? item.top : currentRowTop;
      currentRow.push(item.element);
    } else {
      rows.push(currentRow);
      currentRow = [item.element];
      currentRowTop = item.top;
    }
  }
  if (currentRow.length) {
    rows.push(currentRow);
  }

  rows.forEach(row => {
    const maxHeight = Math.max(...row.map(el => el.offsetHeight));
    row.forEach(el => {
      el.style.height = `${maxHeight}px`;
    });
  });
}

// helper
function sortFacetOptions(facet) {
  if (facet.key == `${prefixData}_pim.author`) {
    // sort by alphabet
    facet.available.sort((a, b) => {
      return a.value.localeCompare(b.value);
    });
  } else if (facet.key == `${prefixData}_pim.global_binding`) {
    // sort by alphabet
    facet.available.sort((a, b) => {
      return a.value.localeCompare(b.value);
    });
  } else if (facet.key == `${prefixData}_pim.purchasing_group`) {
    // sort by alphabet with prefix removed
    facet.available.sort((a, b) => {
      let valueA = a.value;
      if (valueA.includes('-')) {
        valueA = valueA.substring(valueA.indexOf('-') + 1).trim();
      }
      let valueB = b.value;
      if (valueB.includes('-')) {
        valueB = valueB.substring(valueB.indexOf('-') + 1).trim();
      }
      return valueA.localeCompare(valueB);
    });
  } else if (facet.key == `${prefixData}_pim.language`) {
    // sort by alphabet
    facet.available.sort((a, b) => {
      return a.value.localeCompare(b.value);
    });
  } else if (facet.key == `${prefixData}_pim.series_name_reference`) {
    // sort by alphabet
    facet.available.sort((a, b) => {
      return a.value.localeCompare(b.value);
    });
  } else if (facet.key == `${prefixData}_pim.publisher`) {
    // sort by alphabet
    facet.available.sort((a, b) => {
      return a.value.trim().localeCompare(b.value.trim());
    });
  } else if (facet.key == `${prefixData}_pim.brand`) {
    // sort by alphabet
    facet.available.sort((a, b) => {
      return a.value.localeCompare(b.value);
    });
  } else if (facet.key == `${prefixData}_pim.age`) {
    // sort values by number. values maybe 2-4, 2-12, 2-6, 2+, 3+, 11+, 1, 11, 0 til 36 måneder, 0 til 12 måneder
    // the new list should be 0 til 12 måneder, 0 til 36 måneder, 1, 2-4, 2-6, 2-12, 2+, 3+, 11, 11+
    // Helper: parse value to get type and sort keys
    function getAgeSortKey(v) {
      // "0 til 12 måneder" or similar (always starts with 0, space, 'til')
      const tilMndRegex = /^0\s*til\s*(\d{1,3})\s*måneder$/i;
      let m = v.match(tilMndRegex);
      if (m) {
        // High priority, sort first by range end, then alphabetically
        // Prepend 0 so they come before single number
        return { group: 0, n: parseInt(m[1]), raw: v };
      }
      // Range "a-b"
      let range = v.match(/^(\d+)\s*-\s*(\d+)$/);
      if (range) {
        return { group: 2, n: parseInt(range[1]), n2: parseInt(range[2]), raw: v };
      }
      // Plus, e.g. "2+"
      let plus = v.match(/^(\d+)\+$/);
      if (plus) {
        return { group: 3, n: parseInt(plus[1]), raw: v };
      }
      // Plus, e.g. "11+" (catch stray, also covered by above)
      let plus2 = v.match(/^(\d{1,3})\+$/);
      if (plus2) {
        return { group: 3, n: parseInt(plus2[1]), raw: v };
      }
      // Single number, e.g. "1", "11"
      let num = v.match(/^(\d{1,3})$/);
      if (num) {
        return { group: 1, n: parseInt(num[1]), raw: v };
      }
      // fallback
      return { group: 100, n: 9999, raw: v };
    }

    facet.available.sort((a, b) => {
      const ka = getAgeSortKey(a.value);
      const kb = getAgeSortKey(b.value);
      // sort by group, then primary number
      if (ka.group !== kb.group) return ka.group - kb.group;
      if (ka.n !== kb.n) return ka.n - kb.n;
      // for ranges, sort by upper bound secondarily
      if (ka.group === 2 && kb.group === 2 && ka.n2 !== kb.n2) return ka.n2 - kb.n2;
      // fallback: alphabetical order (for true ties)
      return ka.raw.localeCompare(kb.raw);
    });

  } else if (facet.key == `${prefixData}_pim.number_of_participants`) {
    // sort values by number. values maybe 2-4, 2-12, 2-6, 2+, 1, 11
    facet.available.sort((a, b) => {
      // Enhanced parser: supports single, plus, and range values like "2-4", "2-12", etc.
      function parseValue(val) {
        val = val.trim();
        // e.g. "2-4", "2-12"
        let rangeMatch = val.match(/^(\d+)\s*-\s*(\d+)$/);
        if (rangeMatch) {
          return { type: 'range', from: parseInt(rangeMatch[1]), to: parseInt(rangeMatch[2]), raw: val };
        }
        // e.g. "2+"
        let plusMatch = val.match(/^(\d+)\+$/);
        if (plusMatch) {
          return { type: 'plus', from: parseInt(plusMatch[1]), to: Infinity, raw: val };
        }
        // e.g. "1", "11"
        let singleMatch = val.match(/^(\d+)$/);
        if (singleMatch) {
          return { type: 'single', from: parseInt(singleMatch[1]), to: parseInt(singleMatch[1]), raw: val };
        }
        // Fallback, parse with lowest priority
        return { type: 'other', from: 99999, to: 99999, raw: val };
      }

      let aParsed = parseValue(a.value);
      let bParsed = parseValue(b.value);

      // Sort first by the lowest value (from)
      if (aParsed.from !== bParsed.from) {
        return aParsed.from - bParsed.from;
      }

      // If froms are equal, prioritize type: single < plus < range < other
      const typeOrder = { single: 0, plus: 1, range: 2, other: 3 };
      if (typeOrder[aParsed.type] !== typeOrder[bParsed.type]) {
        return typeOrder[aParsed.type] - typeOrder[bParsed.type];
      }

      // If range, further sort by 'to' value ("2-4" < "2-6" < "2-12")
      if (aParsed.type === 'range' && bParsed.type === 'range') {
        if (aParsed.to !== bParsed.to) {
          return aParsed.to - bParsed.to;
        }
      }

      // fallback: alphabetical
      return aParsed.raw.localeCompare(bParsed.raw);
    });
  }
  return facet;
}

// helper
function renderLabel(label, facetKey) {
  let shouldMapName = false;
  let shouldMapLanguage = false;
  if (facetKey == `${prefixData}_pim.global_binding` && window.relewiseAPI.pim_binding_type_mapping && window.relewiseAPI.pim_binding_type_mapping.length) {
    shouldMapName = true;
  }
  if (facetKey == `${prefixData}_pim.language` && window.themeVariables.settings.languageMapping && window.themeVariables.settings.languageMapping.length) {
    shouldMapLanguage = true;
  }
  if (shouldMapName) {
    let bindingTypeItem = window.relewiseAPI.pim_binding_type_mapping.find(item => {
      let itemParts = item.split(':');
      return itemParts[0].toLowerCase().trim() == label.toLowerCase().trim();
    });
    if (bindingTypeItem) {
      label = bindingTypeItem.split(':')[1].trim();
    }
  }
  if (shouldMapLanguage) {
    let languageItem = window.themeVariables.settings.languageMapping.find(item => {
      let itemParts = item.split(':');
      return itemParts[0].toLowerCase().trim() == label.toLowerCase().trim();
    });
    if (languageItem) {
      label = languageItem.split(':')[1].trim();
    }
  }
  if (facetKey == `${prefixData}_pim.purchasing_group`) {
    if (label.includes('-')) {
      label = label.substring(label.indexOf('-') + 1).trim();
    }
    label = label.charAt(0).toUpperCase() + label.slice(1).toLowerCase();
  }
  if (facetKey == `${prefixData}_pim.global_binding`) {
    // Title-case first word and lowercase the rest, but keep acronyms (CD, DVD, CD-R, CD-ROM) uppercase, e.g. BOG & CD -> Bog & CD
    const acronyms = ['cd', 'dvd', 'cd-r', 'cd-rom', 'ebog', 'pdf', 'mp3', 'mp3-cd', 'dvd-rom', 'ean'];
    label = label.split(/\s+/).map((word, i) => {
      if (word === '&' || word.length === 0) return word;
      const wordLower = word.toLowerCase();
      if (acronyms.includes(wordLower)) return wordLower.toUpperCase();
      // Only upcase if this is the first word in the label
      return i === 0
        ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        : word.toLowerCase();
    }).join(' ');
    if (label == 'Ean-vare') {
      label = 'EAN-vare';
    }
  }
  return label;
}

// Retail Media
function renderRetailMedia(data) {
  if (!data.responses?.length || !data.responses[0].retailMedia?.placements || window.currentPage != 1 || document.querySelector('.relewise-collection-page-wrapper .removable-facet')) {
    return;
  }
  const placements = data.responses[0].retailMedia.placements;
  const productsWrapper = document.querySelector('.relewise-collection-page-wrapper .product-list');
  if (!productsWrapper) {
    return;
  }

  Object.entries(placements).forEach(([placementKey, placement]) => {
    const results = placement?.results;
    if (!Array.isArray(results)) {
      return;
    }
    results.forEach((item) => {
      const ad = item?.promotedDisplayAd?.result;
      if (!ad?.data) {
        return;
      }
      const data = ad.data;
      const imageUrl = data.Image?.value || '';
      const title = data.Title?.value || '';
      const subtitle = data.Subtitle?.value || '';
      const linkUrl = data.Link?.value || '#';
      if (!imageUrl) {
        return;
      }
      const bannerHtml = `
        <div class="relewise-retail-media-banner product-list__promo group text-custom" data-placement="${escapeHtml(placementKey)}">
          <a href="${escapeHtml(linkUrl)}" class="content-over-media h-full rounded-sm">
            <img class="product-card__image product-card__image--primary aspect-custom" src="${escapeHtml(imageUrl)}" loading="lazy" alt="${escapeHtml(title)}" width="204">
            ${title || subtitle ? `<div class="place-self-end-start text-start">
              <div class="v-stack gap-4 sm:gap-6 "><div class="prose">
              ${title ? `<p class="relewise-retail-media-heading h4">${escapeHtml(title)}</p>` : ''}
              ${subtitle ? `<p class="relewise-retail-media-subtitle">${escapeHtml(subtitle)}</p>` : ''}
            </div></div></div>` : ''}
          </a>
        </div>`;
      const bannerEl = document.createElement('div');
      bannerEl.innerHTML = bannerHtml.trim();
      const banner = bannerEl.firstChild;
      const spotPositions = {
        'FIRST_SPOT': 1,
        'SECOND_SPOT': 2,
        'THIRD_SPOT': 3,
        'FOURTH_SPOT': 4,
        'FIFTH_SPOT': 5,
        'SIXTH_SPOT': 6,
        'SEVENTH_SPOT': 7,
        'EIGHTH_SPOT': 8,
        'NINTH_SPOT': 9,
        'TENTH_SPOT': 10
      };
      const position = spotPositions[placementKey];
      if (position != null) {
        if (position > productsWrapper.children.length) {
          productsWrapper.appendChild(banner);
        } else {
          productsWrapper.insertBefore(banner, productsWrapper.children[position - 1]);
        }
      }
    });
  });
}

function renderCollectionPromotions() {
  if (window.collectionPromotionImages && window.collectionPromotionImages.length && window.currentPage == 1 && !document.querySelector('.relewise-collection-page-wrapper .removable-facet')) {
    const productsWrapper = document.querySelector('.relewise-collection-page-wrapper .product-list');
    if (!productsWrapper) {
      return;
    }
    window.collectionPromotionImages.forEach(item => {
      let position = item.position;
      const div = document.createElement('div');
      div.innerHTML = item.html;
      const node = div.firstChild;
      // insert item to product list at position. If position > productsWrapper.children.length, append to the end.
      if (position > productsWrapper.children.length) {
        productsWrapper.appendChild(node);
      } else {
        productsWrapper.insertBefore(node, productsWrapper.children[position - 1]);
      }
    });
  }
}

function escapeHtml(unsafe) {
  if (unsafe == null || typeof unsafe !== 'string') {
    return '';
  }
  const div = document.createElement('div');
  div.textContent = unsafe;
  return div.innerHTML;
}

document.addEventListener('relewise:facets:update', function(event) {
  let facets = {};
  let form = event.detail.form;
  let activeFacets = event.detail.activeFacets;
  let page = 1;
  if (event.detail.page) {
    page = event.detail.page;
  }
  if (activeFacets) {
    facets = activeFacets;
  } else {
    let formData = new FormData(form);
    formData.forEach((value, key) => {
      if (key.startsWith('search-')) {
        return;
      }
      if (key == 'sort_by') {
        if (value == 'manual') {
          window.currentSorting = '';
          return;
        }
        facets[key] = value;
        return;
      }
      if (key == 'filter.v.price.gte') {
        let min = parseFloat(form.querySelector('input[name="filter.v.price.gte"]').getAttribute('min'));
        if (value > min) {
          facets[key] = value;
        }
        return;
      }
      if (key == 'filter.v.price.lte') {
        let max = parseFloat(form.querySelector('input[name="filter.v.price.lte"]').getAttribute('max'));
        if (value < max) {
          facets[key] = value;
        }
        return;
      }
      key = key.replace('rlw-', '');
      if (facets.hasOwnProperty(key)) {
        if (Array.isArray(facets[key])) {
          facets[key].push(value);
        } else {
          facets[key] = [facets[key], value];
        }
      } else {
        facets[key] = [value];
      }
    });
  }

  window.currentSorting = window.currentSorting || '';
  if (facets.hasOwnProperty('sort_by')) {
    window.currentSorting = facets['sort_by'];
  }

  let isSearchPage = document.body.classList.contains('template-search');

  if (isSearchPage) {
    let searchWrapper = document.querySelector('.relewise-search-page-wrapper');
    if (!searchWrapper) return;
    let productTerms = document.querySelector('.main-search-form input[name="q"]').value;
    let productPerPage = parseInt(document.querySelector('input[name="search_page_config"]').dataset.productperpage);

    searchWrapper.classList.add('is-loading');
    window.currentSearchPage = page;
    renderRelewiseSearchPage(productTerms, page, productPerPage, window.currentSorting, facets)
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        searchWrapper.scrollIntoView({ behavior: 'smooth' });
        searchWrapper.classList.remove('is-loading');
      });
    return;
  }

  let collectionInput = document.querySelector('input[name="collection_id"]');
  if (!collectionInput) return;
  let collectionId = collectionInput.value;
  let productPerPage = collectionInput.dataset.productperpage;

  document.querySelector('.relewise-collection-page-wrapper').classList.add('is-loading');
  getItemCollectionPage(collectionId, productPerPage, page, window.currentSorting, facets).then((data) => {
    renderCollectionFromRelewise(data);
  }).catch((error) => {
    console.log(error);
  }).finally(() => {
    document.querySelector('.relewise-collection-page-wrapper').scrollIntoView({ behavior: 'smooth' });
    document.querySelector('.relewise-collection-page-wrapper').classList.remove('is-loading');
    updateRelewiseUrlParams(facets, window.currentPage, 'collection');
  });
});

function updateRelewiseUrlParams(facets, currentPage, context, productTerms) {
  let urlParams = new URLSearchParams();
  if (context === 'search' && productTerms) {
    urlParams.set('q', productTerms);
  }
  if (currentPage > 1) {
    urlParams.set('page', currentPage);
  }
  if (window.currentSorting && window.currentSorting != 'manual') {
    urlParams.set('sort_by', window.currentSorting);
  }

  Object.keys(facets).forEach(key => {
    if (key === 'sort_by') return;
    if (Array.isArray(facets[key])) {
      if (facets[key].length) {
        urlParams.set(key.replace(`${prefixData}_`, 'rlw_'), facets[key]);
      }
    } else {
      if (facets[key]) {
        urlParams.set(key.replace(`${prefixData}_`, 'rlw_'), facets[key]);
      }
    }
  });

  let url = window.location.href.split('?')[0];
  if (urlParams.toString() !== '') {
    url = url + '?' + urlParams.toString();
  }
  window.history.replaceState(null, '', url);
}

document.addEventListener('click', function(event) {
  // sort dropdown (desktop)
  if (event.target.closest('#relewise-collection-sort .popover-listbox__option')) {
    event.preventDefault();
    let sortOptionElement = event.target.closest('#relewise-collection-sort .popover-listbox__option');
    let sortValue = sortOptionElement.getAttribute('value');
    if (document.querySelector('.rlw-drawer-sort-by') && sortValue != window.currentSorting) {
      document.querySelector(`.rlw-drawer-sort-by .checkbox-list input[name="sort_by"][value="${sortValue}"]`).checked = true;
      let form = document.querySelector('.facets-drawer-relewise #facet-form');
      document.dispatchEvent(new CustomEvent("relewise:facets:update", { bubbles: true, detail: { form: form } }));
    }
  }

  // facet toggle button (desktop)
  if (event.target.closest('.relewise-collection-page-wrapper .facet-toggle-btn, .relewise-search-page-wrapper .facet-toggle-btn')) {
    event.preventDefault();
    let facetToggleButtonElement = event.target.closest('.facet-toggle-btn');
    let facetKey = facetToggleButtonElement.dataset.key;
    if (facetKey) {
      let facetElement = document.querySelector(`.facets-drawer #facet-form details[data-key="${facetKey}"]`);
      if (facetElement) {
        // close all other facets
        document.querySelectorAll('.facets-drawer #facet-form details').forEach(item => {
          if (item.getAttribute('data-key') != facetKey) {
            item.removeAttribute('open');
          }
        });
        facetElement.querySelector('.accordion__toggle').click();
      }
    }
  }

  // remove filter (desktop & mobile)
  if (event.target.closest('.relewise-collection-page-wrapper .removable-facet a, .relewise-search-page-wrapper .removable-facet a')) {
    event.preventDefault();
    let removeFacetElement = event.target.closest('.removable-facet a');
    let facetKey = removeFacetElement.dataset.facetKey;
    if (facetKey == 'price') {
      window.activeFacets['filter.v.price.gte'] = '';
      window.activeFacets['filter.v.price.lte'] = '';
    } else {
      let facetValue = removeFacetElement.dataset.facetValue;
      window.activeFacets[facetKey] = window.activeFacets[facetKey].filter(value => value != facetValue);
    }
    let form = document.querySelector('.facets-drawer-relewise #facet-form');
    document.dispatchEvent(new CustomEvent("relewise:facets:update", { bubbles: true, detail: { form: form, activeFacets: window.activeFacets } }));
  }

  // clear all filters (desktop & mobile)
  if (event.target.closest('.relewise-collection-page-wrapper .rlw-facet-clear-all, .relewise-search-page-wrapper .rlw-facet-clear-all')) {
    event.preventDefault();
    let form = document.querySelector('.facets-drawer-relewise #facet-form');
    window.activeFacets = {};
    document.dispatchEvent(new CustomEvent("relewise:facets:update", { bubbles: true, detail: { form: form, activeFacets: window.activeFacets } }));
  }

  // collection pagination (desktop & mobile)
  if (event.target.closest('.relewise-collection-page-wrapper .pagination__item')) {
    event.preventDefault();
    let paginationElement = event.target.closest('.relewise-collection-page-wrapper .pagination__item');
    let rel = paginationElement.getAttribute('rel');
    if (rel == 'prev') {
      window.currentPage = window.currentPage - 1;
    } else if (rel == 'next') {
      window.currentPage = window.currentPage + 1;
    }
    let form = document.querySelector('.facets-drawer-relewise #facet-form');
    document.dispatchEvent(new CustomEvent("relewise:facets:update", { bubbles: true, detail: { form: form, page: window.currentPage } }));
  }

  // search page pagination (desktop & mobile)
  if (event.target.closest('.search__pagination-relewise .pagination__item')) {
    event.preventDefault();
    let paginationElement = event.target.closest('.search__pagination-relewise .pagination__item');
    if (paginationElement.classList.contains('pagination__item--disabled')) return;
    let rel = paginationElement.getAttribute('rel');
    if (rel == 'prev') {
      window.currentSearchPage = window.currentSearchPage - 1;
    } else if (rel == 'next') {
      window.currentSearchPage = window.currentSearchPage + 1;
    }
    let form = document.querySelector('.facets-drawer-relewise #facet-form');
    if (form) {
      document.dispatchEvent(new CustomEvent("relewise:facets:update", { bubbles: true, detail: { form: form, page: window.currentSearchPage, activeFacets: window.activeFacets } }));
    } else {
      let productTerms = document.querySelector('.main-search-form input[name="q"]').value;
      let productPerPage = parseInt(document.querySelector('input[name="search_page_config"]').dataset.productperpage);
      renderRelewiseSearchPage(productTerms, window.currentSearchPage, productPerPage);
      document.querySelector('.relewise-search-page-wrapper').scrollIntoView({ behavior: 'smooth' });
    }
  }

  // search page tab switching — only show pagination on products tab
  let searchTabButton = event.target.closest('.relewise-search-page-wrapper .predictive-search__tab-item button');
  if (searchTabButton) {
    let tabItem = searchTabButton.closest('.predictive-search__tab-item');
    let paginationNav = document.querySelector('.search__pagination-relewise');
    if (paginationNav) {
      if (tabItem && tabItem.dataset.type === 'products' && window.searchPageTotalPages > 1) {
        paginationNav.classList.remove('hidden');
      } else {
        paginationNav.classList.add('hidden');
      }
    }
  }
});

document.addEventListener('input', function(event) {
  if (event.target.closest('input.rlw-facet-search')) {
    event.preventDefault();
    let inputElement = event.target.closest('input.rlw-facet-search');
    let parentCheckboxListElement = inputElement.closest('.accordion__content')?.querySelector('.checkbox-list');
    if (!parentCheckboxListElement) {
      return;
    }
    let key = inputElement.dataset.key;
    let inputValue = inputElement.value;
    if (key && window.relewiseFacets && window.relewiseFacets[key] && window.relewiseFacets[key].length) {
      let values = window.relewiseFacets[key].slice(0, 10);
      if (inputValue) {
        values = window.relewiseFacets[key].filter(option => option.value.toLowerCase().includes(inputValue.toLowerCase()) || renderLabel(option.value, key).toLowerCase().includes(inputValue.toLowerCase()));
      }
      let currentCheckedValues = [];
      parentCheckboxListElement.querySelectorAll('input[type="checkbox"]:checked').forEach(input => {
        currentCheckedValues.push(input.value);
      });
      let checkboxListHtml = '';
      values = values.slice(0, 10);
      values.forEach(option => {
        if (currentCheckedValues.includes(option.value)) {
          return;
        }
        let label = renderLabel(option.value, key);
        checkboxListHtml += `<div class="checkbox-container">
          <input type="checkbox" class="checkbox" name="rlw-${key}" value="${option.value}" id="${key}-${option.value}" ${option.selected ? 'checked' : ''}>
          <label for="${key}-${option.value}">${label} (${option.hits})</label>
        </div>`;
      });
      parentCheckboxListElement.querySelectorAll('.checkbox-container').forEach(container => {
        if (!currentCheckedValues.includes(container.querySelector('input[type="checkbox"]').value)) {
          container.remove();
        }
      });
      // Instead of appending to innerHTML (which can remove event listeners and checked status), use DOM operations to only add missing options.
      // Parse the checkboxListHtml into DOM nodes and append them.
      if (checkboxListHtml) {
        const temp = document.createElement('div');
        temp.innerHTML = checkboxListHtml;
        // Append each child node to the checkbox-list element without touching what's already present
        Array.from(temp.childNodes).forEach(node => {
          parentCheckboxListElement.appendChild(node);
        });
      }
    }
  }
});

function getVisitorId() {
  if (Shopify && Shopify.customerPrivacy) {
    let currentConsent = Shopify.customerPrivacy.currentVisitorConsent();
    if (currentConsent && currentConsent.marketing == 'yes' && currentConsent.analytics == 'yes') {
      if (window.relewiseAPI.customer_id) {
        return window.relewiseAPI.customer_id;
      } else {
        let visitorId = localStorage.getItem('relewise_visitor_id');
        if (!visitorId) {
          if (Shopify.customerPrivacy.consentId()) {
            visitorId = Shopify.customerPrivacy.consentId();
          } else {
            visitorId = ''
          }
          localStorage.setItem('relewise_visitor_id', visitorId);
        }
        return visitorId;
      }
    }
  } else if (sessionStorage.getItem('consent_accepted') == 'true') {
    if (window.relewiseAPI.customer_id) {
      return window.relewiseAPI.customer_id;
    } else if (localStorage.getItem('relewise_visitor_id')) {
      return localStorage.getItem('relewise_visitor_id');
    } else {
      return '';
    }
  } else {
    return '';
  }
}

async function updateRelewiseUserId() {
  if (Shopify && Shopify.customerPrivacy) {
    if (sessionStorage.getItem('relewise_user_updated') == 'true') {
      return;
    }
    let currentConsent = Shopify.customerPrivacy.currentVisitorConsent();
    if (currentConsent && currentConsent.marketing == 'yes' && currentConsent.analytics == 'yes') {
      sessionStorage.setItem('consent_accepted', 'true');
      let visitorId = localStorage.getItem('relewise_visitor_id');
      if (visitorId && window.relewiseAPI.customer_id && visitorId != window.relewiseAPI.customer_id) {
        // update user Relewise
        const tracker = new Relewise.Tracker(window.relewiseAPI.relewise_dataid, window.relewiseAPI.relewise_api, {
          serverUrl: window.relewiseAPI.relewise_server_url,
        });
        let user = Relewise.UserFactory.byAuthenticatedId(window.relewiseAPI.customer_id, visitorId, {});
        await tracker.trackUserUpdate({user});
        sessionStorage.setItem('relewise_user_updated', 'true');
      }
    } else {
      if (sessionStorage.getItem('consent_accepted') == 'true') {
        sessionStorage.removeItem('consent_accepted');
      }
      if (sessionStorage.getItem('relewise_user_updated')) {
        sessionStorage.removeItem('relewise_user_updated');
      }
    }
  }
}

function afterConsentLibraryLoaded() {
  window.temporaryId = getVisitorId();
  // Update temporary id and customer id if needed
  updateRelewiseUserId();
}

document.addEventListener('DOMContentLoaded', function() {
  window.Shopify.loadFeatures([{
    name: "consent-tracking-api",
    version: "0.1",
    onLoad: afterConsentLibraryLoaded.bind(this)
  }]);
  window.temporaryId = getVisitorId();

  // if (temporaryId != '' && !document.body.classList.contains('cart-added-tempid')) {
    // TODO: relewise tracking
    // setCartAttributes({ temporary_id: `${temporaryId}` });
  // }
  // get ResponseTrack
  const isProductPage = document.body.classList.contains('template-product');
  const isSeachPage = document.body.classList.contains('template-search');
  const isCartPage = document.body.classList.contains('template-cart');
  const isCollectionPage = document.body.classList.contains('template-collection');

  if (isProductPage) {
    // let productId = document.querySelector('input[name="product_handle_tracking"]').value;
    // let variantId = document.querySelector('input[name="product_handle_tracking_varianid"]').value;
    // TODO: relewise tracking
    // getResponseTrackProductViewRequest(productId, variantId);

  }

  if (isSeachPage) {
    let productPerPage = parseInt(document.querySelector('input[name="search_page_config"]').dataset.productperpage);
    window.currentSearchPage = 1;

    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('page')) {
      window.currentSearchPage = parseInt(urlParams.get('page'));
    }
    window.currentSorting = '';
    if (urlParams.has('sort_by')) {
      window.currentSorting = urlParams.get('sort_by');
    }
    let initialFacets = {};
    urlParams.forEach((value, key) => {
      if (key === 'page' || key === 'sort_by' || key === 'q' || key === 'type') {
        return;
      }
      if (key.startsWith('rlw_')) {
        if (value.indexOf(',') !== -1) {
          initialFacets[key.replace('rlw_', `${prefixData}_`)] = value.split(',');
        } else {
          initialFacets[key.replace('rlw_', `${prefixData}_`)] = [value];
        }
      } else if (key === 'filter.v.price.gte' || key === 'filter.v.price.lte') {
        initialFacets[key] = value;
      }
    });

    let productTerms = document.querySelector('.main-search-form input[name="q"]').value.trim();
    if (productTerms.length >= 2) {
      saveSearchTerm(productTerms);
      document.querySelector('.shopify-section--main-search h1').textContent = window.themeVariables.ir.search.mainSearchPlaceholder + ' ' + "\"" + productTerms + "\"";
      renderRelewiseSearchPage(productTerms, window.currentSearchPage, productPerPage, window.currentSorting, initialFacets);
    } else {
      document.querySelector('.shopify-section--main-search h1').textContent = window.themeVariables.ir.search.mainSearchPlaceholder + ' ' + "\"" + "\"";
      renderPopularProductsOnSearchPage(productPerPage);
    }

    let searchDebounceTimer;
    document.querySelector('.main-search-form input[name="q"]').addEventListener('input', function(event) {
      clearTimeout(searchDebounceTimer);
      searchDebounceTimer = setTimeout(function() {
        let productTerms = event.target.value.trim();
        if (productTerms.length >= 2) {
          saveSearchTerm(productTerms);
          document.querySelector('.shopify-section--main-search h1').textContent = window.themeVariables.ir.search.mainSearchPlaceholder + ' ' + "\"" + productTerms + "\"";
          window.currentSearchPage = 1;
          window.currentSorting = '';
          window.activeFacets = {};
          renderRelewiseSearchPage(productTerms, window.currentSearchPage, productPerPage);
        } else {
          document.querySelector('.shopify-section--main-search h1').textContent = window.themeVariables.ir.search.mainSearchPlaceholder + ' ' + "\"" + "\"";
          renderPopularProductsOnSearchPage(productPerPage);
        }
      }, 500);
    });
  }

  if (isCartPage) {
    // TODO: relewise cart upsell
    // let temporaryId = getVisitorId();
    // let temporaryIdInput = document.querySelector('input[name="attributes[TemporaryId]"]');
    // if (temporaryId != '') {
    //   temporaryIdInput.value = temporaryId;
    // }
    // getUpsellCart();
  }

  if (isCollectionPage) {
    let collectionInput = document.querySelector('input[name="collection_id"]');
    let collectionId = collectionInput.value;
    let productPerPage = collectionInput.dataset.productperpage;
    let page = 1;

    // No `is-loading` class is added on initial load: the server-rendered
    // skeleton cards inside <product-list> already convey the loading state
    // and prevent CLS. The fullscreen spinner overlay (.is-loading wrapper)
    // is reserved for re-fetches (facet/sort/pagination) where users need
    // explicit feedback that something changed.
    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('page')) {
      page = urlParams.get('page');
    }
    window.currentSorting = '';
    if (urlParams.has('sort_by')) {
      window.currentSorting = urlParams.get('sort_by');
    }
    let facets = {};
    urlParams.forEach((value, key) => {
      if (key == 'page') {
        return;
      }
      if (key == 'sort_by') {
        return;
      }
      if (key.startsWith('rlw_')) {
        if (value.indexOf(',') !== -1) {
          facets[key.replace('rlw_', `${prefixData}_`)] = value.split(',');
        } else {
          facets[key.replace('rlw_', `${prefixData}_`)] = [value];
        }
      } else {
        facets[key] = value;
      }
    });
    getItemCollectionPage(collectionId, productPerPage, page, window.currentSorting, facets).then((data) => {
      renderCollectionFromRelewise(data);
    }).catch((error) => {
      console.log(error);
    }).finally(() => {
      document.querySelector('.relewise-collection-page-wrapper').classList.remove('is-loading');
    });


  }

  // Recommendations
  fetchAndRenderRecommendations();
  // Cart drawer recommendations are fetched lazily when the drawer opens
  // (see the `dialog:after-show` listener below) to avoid a needless
  // PurchasedWithMultipleProductsRequest on every page load.

  // Featured Collection JSON Product IDs
  if (window.featuredCollectionJsonProducts && Object.keys(window.featuredCollectionJsonProducts).length > 0) {
    document.querySelectorAll('.featured-collection-json-wrapper').forEach(wrapper => {
      wrapper.classList.add('is-loading');
    });

    fetchFeaturedCollectionJsonProducts().then((responses) => {
      Object.entries(responses).forEach(([sectionId, products]) => {
        const wrapper = document.querySelector(`.featured-collection-json-wrapper[data-section-id="${sectionId}"]`);
        if (!wrapper || !products.length) return;

        wrapper.innerHTML = '';
        products.forEach((product, index) => {
          let productCard = buildProductCardHtml(product);
          if (index === 0) {
            productCard.classList.add('is-selected');
          }
          wrapper.appendChild(productCard);
        });

        const scrollAreaId = wrapper.closest('scroll-carousel').id;
        const controlsContainer = wrapper.closest('.floating-controls-container');
        if (controlsContainer && !controlsContainer.querySelector('[is="prev-button"]')) {
          controlsContainer.innerHTML += `<button is="prev-button" class="circle-button circle-button--lg circle-button--fill border group" aria-controls="${scrollAreaId}" disabled>
            <span class="sr-only">{{ 'general.accessibility.previous' | t }}</span>
            <span class="animated-arrow animated-arrow--reverse"></span>
          </button>
          <button is="next-button" class="circle-button circle-button--lg circle-button--fill border group" aria-controls="${scrollAreaId}">
            <span class="sr-only">{{ 'general.accessibility.next' | t }}</span>
            <span class="animated-arrow"></span>
          </button>`;
        }
      });
    }).catch((error) => {
      console.error('Featured collection JSON products error:', error);
    }).finally(() => {
      document.querySelectorAll('.featured-collection-json-wrapper').forEach(wrapper => {
        wrapper.classList.remove('is-loading');
      });
    });
  }

  async function fetchFeaturedCollectionJsonProducts() {
    const settings = {
      language: `${window.themeVariables.settings.languages}`,
      currency: `${window.themeVariables.settings.shopCurrency}`,
      displayedAtLocation: 'Featured Collection',
      user: getUserData()
    };

    const searcher = new Relewise.Searcher(window.relewiseAPI.relewise_dataid, window.relewiseAPI.relewise_api, {
      serverUrl: window.relewiseAPI.relewise_server_url,
    });

    const responses = {};

    for (const [sectionId, config] of Object.entries(window.featuredCollectionJsonProducts)) {
      const rawIds = typeof config.productIds === 'string' ? JSON.parse(config.productIds) : config.productIds;
      const productIds = rawIds.map(id => String(id));
      const maxProducts = config.productsCount || productIds.length;

      const builder = new Relewise.ProductSearchBuilder(settings)
        .setSelectedProductProperties({
          displayName: true,
          dataKeys: PRODUCT_DATA_KEYS,
          pricing: true
        })
        .setSelectedVariantProperties({ dataKeys: [`${prefixData}_ShopifyVariantId`] })
        .filters(f => f.addProductIdFilter(productIds))
        .pagination(p => p.setPageSize(maxProducts));

      try {
        const response = await searcher.searchProducts(builder.build());
        responses[sectionId] = response.results || [];
      } catch (error) {
        console.error(`Failed to fetch products for section ${sectionId}:`, error);
        responses[sectionId] = [];
      }
    }

    return responses;
  }

});

async function getRecommendationProducts() {
  const productRecommendationsBuilder = new Relewise.ProductsRecommendationCollectionBuilder();

  Object.values(window.relewiseRecommendations).forEach(recommendation => {
    let type = recommendation.recommendationType;
    let productId = recommendation.productId;
    let count = recommendation.productsCount;
    let collectionId = recommendation.collectionId;
    const settings = {
      language: `${window.themeVariables.settings.languages}`,
      currency: `${window.themeVariables.settings.shopCurrency}`,
      displayedAtLocation: recommendation.displayedAtLocation || 'Recommendations',
      user: getUserData()
    };

    let builder;
    if (type == 'PopularProducts') {
      builder = new Relewise.PopularProductsBuilder(settings)
        .setSelectedProductProperties({
          displayName: true,
          dataKeys: PRODUCT_DATA_KEYS,
          pricing: true
        })
        .setSelectedVariantProperties({ dataKeys: [`${prefixData}_ShopifyVariantId`] })
        .setNumberOfRecommendations(count);
    } else if (type == 'PersonalProduct') {
      builder = new Relewise.PersonalProductRecommendationBuilder(settings)
        .setSelectedProductProperties({
          displayName: true,
          dataKeys: PRODUCT_DATA_KEYS,
          pricing: true
        })
        .setSelectedVariantProperties({ dataKeys: [`${prefixData}_ShopifyVariantId`] })
        .setNumberOfRecommendations(count);
    } else if (type == 'MostViewed') {
      builder = new Relewise.PopularProductsBuilder(settings)
        .setSelectedProductProperties({
          displayName: true,
          dataKeys: PRODUCT_DATA_KEYS,
          pricing: true
        })
        .setSelectedVariantProperties({ dataKeys: [`${prefixData}_ShopifyVariantId`] })
        .basedOn('MostViewed')
        .setNumberOfRecommendations(count);
    } else if (type == 'ProductsViewedAfterViewingProduct') {
      builder = new Relewise.ProductsViewedAfterViewingProductBuilder(settings)
        .setSelectedProductProperties({
          displayName: true,
          dataKeys: PRODUCT_DATA_KEYS,
          pricing: true
        })
        .setSelectedVariantProperties({ dataKeys: [`${prefixData}_ShopifyVariantId`] })
        .product({ productId: productId })
        .setNumberOfRecommendations(count);
    } else if (type == 'PurchasedWithProduct') {
      builder = new Relewise.PurchasedWithProductBuilder(settings)
        .setSelectedProductProperties({
          displayName: true,
          dataKeys: PRODUCT_DATA_KEYS,
          pricing: true
        })
        .setSelectedVariantProperties({ dataKeys: [`${prefixData}_ShopifyVariantId`] })
        .product({ productId: productId })
        .setNumberOfRecommendations(count);
    } else if (type == 'PurchasedWithCurrentCart') {
      builder = new Relewise.PurchasedWithCurrentCartBuilder(settings)
        .setSelectedProductProperties({
          displayName: true,
          dataKeys: PRODUCT_DATA_KEYS,
          pricing: true
        })
        .setSelectedVariantProperties({ dataKeys: [`${prefixData}_ShopifyVariantId`] })
        .setNumberOfRecommendations(count);
    }

    if (builder && collectionId) {
      builder.filters(f => f.addProductCategoryIdFilter('ImmediateParent', [collectionId]));
    }

    if (builder) {
      productRecommendationsBuilder.addRequest(builder.build());
    }
  });

  const recommender = new Relewise.Recommender(window.relewiseAPI.relewise_dataid, window.relewiseAPI.relewise_api, {
    serverUrl: window.relewiseAPI.relewise_server_url,
  });

  const response = await recommender.batchProductRecommendations(
    productRecommendationsBuilder.build()
  );
  return response;
}

function fetchAndRenderRecommendations() {
  if (!window.relewiseRecommendations || Object.keys(window.relewiseRecommendations).length === 0) {
    return;
  }
  document.querySelectorAll('.relewise-recommendation-wrapper').forEach(wrapper => {
    wrapper.classList.add('is-loading');
  });
  getRecommendationProducts().then((data) => {
    if (data.responses && data.responses.length) {
      Object.keys(window.relewiseRecommendations).forEach((sectionId, index) => {
        data.responses.forEach((response, index2) => {
          if (index == index2 && response.recommendations && response.recommendations.length) {
            let products = response.recommendations;
            let wrapper = document.querySelector(`.relewise-recommendation-wrapper[data-section-id="${sectionId}"]`);
            if (!wrapper) return;
            wrapper.innerHTML = '';
            products.forEach((product, index3) => {
              let productCard = buildProductCardHtml(product);
              if (index3 == 0) {
                productCard.classList.add('is-selected');
              }
              wrapper.appendChild(productCard);
            });
            let scrollAreaId = wrapper.closest('scroll-carousel').id;
            let controlsContainer = wrapper.closest('.floating-controls-container');
            let existingPrev = controlsContainer.querySelector('[is="prev-button"]');
            let existingNext = controlsContainer.querySelector('[is="next-button"]');
            if (existingPrev) existingPrev.remove();
            if (existingNext) existingNext.remove();
            controlsContainer.innerHTML += `<button is="prev-button" class="circle-button circle-button--lg circle-button--fill border group" aria-controls="${scrollAreaId}" disabled>
          <span class="sr-only">{{ 'general.accessibility.previous' | t }}</span>
          <span class="animated-arrow animated-arrow--reverse"></span>
        </button>

        <button is="next-button" class="circle-button circle-button--lg circle-button--fill border group" aria-controls="${scrollAreaId}">
          <span class="sr-only">{{ 'general.accessibility.next' | t }}</span>
          <span class="animated-arrow"></span>
        </button>`;
          }
        });
      });
    }
  }).catch((error) => {
    console.log(error);
  }).finally(() => {
    document.querySelectorAll('.relewise-recommendation-wrapper').forEach(wrapper => {
      wrapper.classList.remove('is-loading');
    });
  });
}

// Lazy-load the cart drawer recommendations the first time the drawer is opened
// after a cart change. We track loaded state per "cart fingerprint" (productIds
// captured in the JSON tag) so reopening without changes doesn't refetch.
let cartDrawerRecommendationsFingerprint = null;

function getCartDrawerFingerprint() {
  const wrapper = document.querySelector('.relewise-cart-drawer-recommendation-wrapper');
  if (!wrapper) return null;
  const productsJson = wrapper.closest('.cart-drawer__recommendations')
    ?.querySelector('.relewise-cart-drawer-products')?.textContent;
  return productsJson ? productsJson.trim() : null;
}

function isCartDrawerOpen() {
  return !!document.querySelector('cart-drawer[open]');
}

function refreshCartDrawerRecommendationsIfNeeded() {
  const fingerprint = getCartDrawerFingerprint();
  if (!fingerprint || fingerprint === cartDrawerRecommendationsFingerprint) {
    return;
  }
  cartDrawerRecommendationsFingerprint = fingerprint;
  fetchAndRenderCartDrawerRecommendations();
}

document.addEventListener('dialog:after-show', function(event) {
  if (event.target?.id === 'cart-drawer') {
    refreshCartDrawerRecommendationsIfNeeded();
  }
});

// Re-fetch recommendations when the theme editor re-renders a section
document.addEventListener('shopify:section:load', function(event) {
  if (event.target.classList.contains('shopify-section--relewise-recommendations')) {
    fetchAndRenderRecommendations();
  }
  if (event.target.querySelector('.relewise-cart-drawer-recommendation-wrapper')) {
    // Invalidate cache so a subsequent drawer open refetches; if the drawer is
    // open in the theme editor, refresh now to reflect the section changes.
    cartDrawerRecommendationsFingerprint = null;
    if (isCartDrawerOpen()) {
      refreshCartDrawerRecommendationsIfNeeded();
    }
  }
});

document.addEventListener('cart:change', function(event) {
  // Invalidate so the next drawer open will refetch with the new cart contents.
  cartDrawerRecommendationsFingerprint = null;
  // If the drawer is already open, refetch immediately after the inner content
  // has been swapped in (matches the timing in CartDrawer._onCartChanged).
  if (!isCartDrawerOpen()) return;
  setTimeout(() => {
    refreshCartDrawerRecommendationsIfNeeded();
  }, event.detail?.baseEvent === 'variant:add' ? 50 : 1300);
});

document.addEventListener('cart:refresh', function() {
  cartDrawerRecommendationsFingerprint = null;
  if (!isCartDrawerOpen()) return;
  setTimeout(() => {
    refreshCartDrawerRecommendationsIfNeeded();
  }, 500);
});

// when window is resized, align height of product cards
window.addEventListener('resize', () => {
  setTimeout(() => {
    window.alignHeight('.product-card .rpc-author', document.body);
  }, 300);
});